export const translations = {
  ar: {
    // Navbar
    'about': 'من نحن',
    'services': 'الخدمات',
    'navAccountMgmt': 'إدارة الحسابات',
    'navConnectoPlatform': 'منصة كونكتو',
    'navIntegrations': 'المنصات المدعومة',
    'pricing': 'الأسعار',
    'partners': 'اتصل بنا',
    'support': 'الدعم',
    'login': 'تسجيل الدخول',
    'freeTrial': 'ابدأ تجربتك المجانية',
    'tryDemo': 'جرب الآن',
    'en': 'EN',
    'ar': 'عربي',

    // Hero Section
    'heroTitle': 'كونكتو تدمج جميع منصات التجارة الإلكترونية في لوحة تحكم واحدة',
    'heroSubtitle': 'إربط متاجرك على أمازون، نون، جوميا، ترنديول وتحكم في الطلبات، المخزون، والأرباح بسهولة.',
    'watchDemo': 'تعرف علي المنصة',
    'merchants': 'تاجر يستخدم كونكتو',
    'merchantsCount': '1000+',

    // Stats Section
    'statsTitle': 'مؤشرات',
    'statsSubtitle': 'بوابتك الأذكى للوصول إلى ملايين العملاء',
    'statsDescription': 'لا نمنحك مجرد أدوات، بل نضع قوة أكبر الأسواق العالمية بين يديك من منصة واحدة',
    'growthRate': 'تسريع وتيرة نمو الأعمال',
    'salesGrowth': 'زيادة الإيرادات',
    'trustedMerchants': 'رضا العملاء',
    'growthRateValue': '20x',
    'salesGrowthValue': '+500%',
    'trustedMerchantsValue': '+2,000',
    
    // What We Can Do For You Section
    'whatWeDoTitle': 'ماذا يمكننا أن نفعل لك؟',
    'whatWeDoSubtitle': 'نحن لا نمنحك مجرد لوحة تحكم، بل نبني لك منظومة نمو متكاملة',
    'weDo1Title': 'تحكم كامل وموحد',
    'weDo1Desc': 'اربط حساباتك في أمازون، نون، جوميا، وترينديول. تابع مبيعاتك ومخزونك من مكان واحد دون تشتت.',
    'weDo2Title': 'ذكاء اصطناعي ينمي أعمالك',
    'weDo2Desc': 'استخدم "ليو" لإنشاء محتوى بيعي جذاب، و"ألفا" لتصميم صور منتجات احترافية تزيد من معدل التحويل.',
    'weDo3Title': 'دقة مالية وضريبية',
    'weDo3Desc': 'احسب أرباحك الحقيقية بدقة مع "إحسبلي" ونسق ضرائبك مع الخبراء لتتجنب المفاجآت المكلفة.',
    'weDo4Title': 'تدريب ودعم الخبراء',
    'weDo4Desc': 'احجز جلسات تدريبية متخصصة واستشارات مع مديري حسابات محترفين لتطوير استراتيجيتك البيعية.',
    'startJourney': 'ابدأ رحلتك الآن',

    // Partners Section
    'integrationTitle': 'شراكات موثوقة. تكاملات قوية. نمو بلا حدود.',
    'integrationSubtitle': 'تكامل سلس مع أكبر منصات التجارة الإلكترونية',
    'integrationDescription': 'أدر أعمالك بسهولة علي أبرز منصات التجارة الإلكترونية في المنطقة من خلال تكاملات API موثوقة وسريعة.',
    'amazonPartnerBadge': 'شريك معتمد من Amazon SPN',
    'noonPartnerBadge': 'تكامل معتمد مع Noon FBPI',
    'jumiaPartnerBadge': 'شريك معتمد من Jumia AMP',
    'trendyolPartnerBadge': 'تكامل معتمد مع Trendyol',

    // Features Section (One Platform)
    'onePlatformTitle': 'منصة واحدة... لإدارة جميع متاجرك الإلكترونية',
    'onePlatformDesc': 'أدر منتجاتك، وطلباتك، ونمو أعمالك عبر أكبر منصات التجارة الإلكترونية في <span class="text-primary font-bold">مصر والخليج</span> من خلال لوحة تحكم موحدة. تدعم كونكتو التكامل مع <span class="text-primary font-bold">أمازون</span>، و<span class="text-primary font-bold">نون</span>، و<span class="text-primary font-bold">جوميا</span>، و<span class="text-primary font-bold">ترينديول</span> لتمنحك تجربة إدارة أكثر كفاءة ونموًا أسرع.',

    // Bilingual homepage media placeholder
    'mediaIntroTitle': 'لمحة عن كونكتو',
    'mediaIntroBody': 'سيُضاف النص التعريفي هنا قريبًا.',
    'mediaIntroVideoComingSoon': 'الفيديو قريبًا',
    'mediaIntroCarouselLabel': 'معرض الفيديو',
    'mediaIntroSlideLabel': 'عنصر فيديو مؤقت',
    'mediaIntroPreviousVideo': 'الفيديو السابق',
    'mediaIntroNextVideo': 'الفيديو التالي',
    'mediaIntroChooseVideo': 'اختر فيديو',
    'mediaIntroShowVideo': 'عرض الفيديو',

    // Solutions Section
    'solutionsTitle': 'الخدمات',
    'solutionsMainTitle': 'كل ما تحتاجه لتنمية أعمالك على منصات التجارة الإلكترونية.. في منصة واحدة',
    'alpha': 'ألفا مساعدك الذكي',
    'alphaDesc': 'مصمم صور المنتجات الذكي',
    'leo': 'ليو مساعدك الذكي',
    'leoDesc': 'مساعدك الذكي لإنشاء المحتوى',
    'ehsably': 'إيما مساعدك الذكي',
    'ehsablyDesc': 'مساعدك الذكي لتسعير منتجاتك',
    'bekam': 'بكام',
    'bekamDesc': 'مساعدك الذكي لتحليل الأسعار',
    'modaq': 'مدقق',
    'modaqDesc': 'مساعدك الشخصي لإعداد الضرائب',
    'moathr': 'مؤثر',
    'moathrDesc': 'تواصل مع مؤثر لزيادة مبيعاتك',
    'ema': 'إيما مساعدك الذكي',
    'emaDesc': 'مساعدتك الذكية لمعلومات التجارة',
    'ahjez': 'أحجز خبير',
    'ahjezDesc': 'مدير حساباتك الإلكتروني',
    'salesLeads': 'فرص البيع',
    'salesLeadsDesc': 'اكتشف المنتجات ذات الفرص العالية للبيع على أمازون',
    'bookTraining': 'احجز تدريب',
    'bookTrainingDesc': 'احجز تدريبًا احترافيًا لبدء وتنمية أعمالك',
    'vendorMarket': 'سوق الموردين',
    'vendorMarketDesc': 'اكتشف أفضل الموردين على أمازون و نون و جوميا و ترنديول',

    // CTA Section
    'ctaBadge': 'انطلق بتجارتك',
    'ctaTitle': 'ابدأ رحلة التحول نحو تجارة أذكى.. وأرباح أكثر استدامة',
    'ctaDescription': 'تجاوز فوضى الإدارة التقليدية. انضم للنخبة التي تدير أعمالها في أمازون ونون بكفاءة مطلقة من واجهة مركزية واحدة.',

    // Why Choose Us Section
    'whyChooseUsTitle': 'لماذا يختار بائعو التجارة الإلكترونية كونكتو؟',
    'whyChooseUsSubtitle': 'لماذا نحن',
    'whyChooseUsDescription': 'كل ما تحتاجه لإنشاء المنتجات، وإدارة متجرك، وتحسين الأداء، وتنمية أعمالك في منصة واحدة، بدءً من أدوات الذكاء الاصطناعي، وصولًا إلى التحليلات الذكية والدعم المتخصص.',
    'trustedBadge': 'شركاء النجاح',
    'trustedTitle': 'موثوق من قبل بائعي الأسواق الإلكترونية',
    'trustedSubtext': 'نساعد العلامات التجارية على النمو عبر أمازون ونون وجوميا وترينديول و كنز',
    'reason1Title': 'أدوات مدعومة بالذكاء الاصطناعي',
    'reason1Desc': 'أنشئ صورًا احترافية للمنتجات، واكتب محتوى متوافقًا مع معايير المنصات، واحسب الرسوم والأرباح، وانشر منتجاتك بسرعة أكبر من خلال أدوات ذكية مصممة خصيصًا لبائعي التجارة الإلكترونية.',
    'reason2Title': 'إدارة متكاملة لعدة منصات',
    'reason2Desc': 'أدر أعمالك على أمازون، نون، جوميا، وترينديول من مكان واحد، مع تكامل سلس يساعدك على إدارة متجرك بكفاءة أعلى عبر أكبر منصات التجارة الإلكترونية.',
    'reason3Title': 'تحليلات ذكية وتقارير لحظية',
    'reason3Desc': 'تابع المبيعات، والمخزون، والأسعار، وأداء المنتجات من خلال لوحة تحكم تفاعلية، تساعدك على اتخاذ قرارات مبنية على البيانات.',
    'reason4Title': 'خبراء ومتخصصون',
    'reason4Desc': 'تعامل مع فريق متخصص في التجارة الإلكترونية يقدم لك خدمات إدارة الحسابات، والاستشارات، والتدريب، والدعم التشغيلي، لمساعدتك على إطلاق أعمالك وتنميتها بثقة.',

    // Reviews Section 
    'reviewsTitle': 'آراء عملاؤنا',
    'reviewsSubtitle': 'ثقة البائعين في جميع أنحاء الشرق الأوسط وشمال أفريقيا',
    'reviewsDescription': '',
    
    'review1Name': 'معاذ',
    'review1Text': 'ساعدتنا كونكتو على التوسع في أمازون السعودية والإمارات، ونون السعودية والإمارات، وTrendyol تركيا. بدءً من إنشاء صفحات المنتجات وتحسينها، وحتى إدارة العمليات اليومية، كان فريقهم شريكًا حقيقيًا في توسعنا إلى أسواق جديدة.',
    
    'review2Name': 'محمد طه',
    'review2Text': 'ساهمت كونكتو في تبسيط إدارة عملياتنا عبر أمازون، نون، وجوميا. من تحسين صفحات المنتجات إلى إدارة المتاجر اليومية، حصلنا على الدعم والخبرة التي احتجناها للنمو بثقة.',
    
    'review3Name': 'علي عثمان',
    'review3Text': 'من خلال منصة كونكتو ، أصبح إنشاء صفحات المنتجات وإدارتها أكثر سهولة، وتحسن أداء متاجرنا بشكل ملحوظ. وخلال موسم الجمعة البيضاء الماضي حققنا زيادة في المبيعات وصلت إلى 5 أضعاف.',

    'review4Name': 'محمد العمودي',
    'review4Text': 'أصبحت إدارة آلاف المنتجات عبر عدة منصات تجارة إلكترونية أكثر سهولة. وفرت علينا كونكتو ساعات طويلة من العمل اليدوي كل أسبوع.',

    'review5Name': 'رحاب مصطفي',
    'review5Text': 'جعلت كونكتو إطلاق متجري الإلكتروني أسهل بكثير. ساعدني الفريق في نشر المنتجات بسرعة وتجنب الأخطاء الشائعة أثناء إعداد المتجر.',

    // Home Page FAQs
    'newHomeFaqSubtitle': 'أسئلة متكررة',
    'newHomeFaqTitle': 'الأسئلة الشائعة',
    'newHomeFaq1Q': 'ما هي كونكتو؟',
    'newHomeFaq1A': 'كونكتو هي منظومة متكاملة لتنمية أعمال التجارة الإلكترونية، تجمع بين منصة مدعومة بالذكاء الاصطناعي وخدمات احترافية لإدارة حسابات المتاجر الإلكترونية. تساعدك على إدارة أعمالك، وتحسين أداء منتجاتك، وتنمية مبيعاتك عبر أمازون، نون، جوميا، ترينديول، كنز، ونمشي.',
    'newHomeFaq2Q': 'ما هي المنصات التي تدعمها كونكتو؟',
    'newHomeFaq2A': 'تدعم كونكتو التكامل مع أمازون، نون، جوميا، ترينديول، كنز، ونمشي في مصر، والسعودية، والإمارات، وتركيا.',
    'newHomeFaq3Q': 'ما الخدمات التي تقدمها كونكتو؟',
    'newHomeFaq3A': 'توفر كونكتو مجموعة متكاملة من الحلول، تشمل: منصة كونكتو "أدوات مدعومة بالذكاء الاصطناعي"، إدارة حسابات المتاجر الإلكترونية، تحسين صفحات المنتجات، إدارة الإعلانات، التحليلات ولوحات التحكم، أدوات التسعير وحساب الأرباح، وخدمات تنمية المتاجر الإلكترونية.',
    'newHomeFaq4Q': 'لمن صُممت كونكتو؟',
    'newHomeFaq4A': 'تناسب كونكتو الشركات الناشئة، والعلامات التجارية المتنامية، والشركات الكبرى التي ترغب في إدارة أعمالها والتوسع عبر أكثر من منصة تجارة إلكترونية.',
    'newHomeFaq5Q': 'كيف أبدأ العمل علي منصة كونكتو؟',
    'newHomeFaq5A': 'يمكنك إنشاء حسابك مباشرة، أو حجز استشارة مجانية، وسيقوم فريقنا بمساعدتك في اختيار الحل الأنسب لاحتياجات أعمالك.',
    'newHomeFaq6Q': 'لماذا كونكتو؟',
    'newHomeFaq6A': 'لأن كونكتو لا تقدم مجرد برنامج أو وكالة لإدارة المتاجر الإلكترونية، بل تجمع بين التكنولوجيا المدعومة بالذكاء الاصطناعي، والخبرة العملية، وخدمات إدارة الحسابات في منظومة واحدة تساعدك على تحقيق نمو مستدام.',
    'newHomeFaq7Q': 'كيف يمكنني التواصل مع كونكتو؟',
    'newHomeFaq7A': 'يمكنك التواصل معنا من خلال الموقع الإلكتروني، أو البريد الإلكتروني، أو [حجز استشارة مجانية مع أحد خبرائنا](/partners/).',

       // Pricing Page General
    'pricingTitle': 'خطط الأسعار',
    'pricingSubtitle': 'خطة لكل ميزانية',
    'pricingDescription': 'عش مستقبل التجارة الإلكترونية مع منصتنا الآمنة والفعالة وسهلة الاستخدام',
    'currency': 'جنيه',
    'currencyUSD': 'دولار',
    'perMonth': '/ شهرياً',
    'startNow': 'ابدأ الآن',

    // Pricing Page (Next.js Content)
    'pricingHeroTitle': 'خطط مرنة تناسب جميع فئات الأعمال',
    'pricingHeroBody': 'سواء كنت تبدأ رحلتك في التجارة الإلكترونية أو تدير نشاطًا متناميًا عبر عدة منصات، توفر كونكتو باقات مرنة تساعدك على إنشاء المنتجات، وتحسينها، وإدارة أعمالك، وتنمية مبيعاتك باستخدام أدوات الذكاء الاصطناعي والدعم المتخصص.',

    'plansHeading': 'منصة كونكتو',
    'plansSubheading': 'اختر الباقة المناسبة لأعمالك، أو صمّم باقتك الخاصة بما يتوافق مع احتياجاتك.',
    
    // Starter Plan
    'planStarter': 'الأساسية',
    'planStarterPriceUSD': '25',
    'starterFeaturesList': [
      'كونكتو ستوديو (30 صفحة منتج) (باستخدام رصيد من أدوات ألفا وليو)',
      'ألفا (150 صورة)',
      'ليو (120 عملية إنشاء محتوى)',
      'إيما (160 استفسارًا)',
      'بكام (30 عملية متابعة لأسعار المنافسين)',
      'احسبلي (حسابات أرباح غير محدودة)',
      'مولد QR والباركود (استخدام غير محدود)',
      'لوحة تحكم كونكتو (تحليلات المبيعات والمخزون) - استخدام غير محدود',
    ],
    'starterCreditsNote': 'توفر الباقة 850 نقطة من الرصيد، الاستخدامات الموضحة هي توزيع مقترح للرصيد، ويمكنك استخدامه بحرية بين الأدوات المتاحة بما يناسب احتياجات أعمالك.',

    // Pro Plan
    'popularLabel': 'الأكثر شيوعًا',
    'planPro': 'الاحترافية',
    'planProPriceUSD': '50',
    'proFeaturesList': [
      'كونكتو ستوديو (60 صفحة منتج) (باستخدام رصيد من أدوات ألفا وليو)',
      'ألفا (300 صورة)',
      'ليو (240 عملية إنشاء محتوى)',
      'إيما (320 استفسارًا)',
      'بكام (60 عملية متابعة لأسعار المنافسين)',
      'احسبلي (حسابات أرباح غير محدودة)',
      'فرص البيع (استخدام غير محدود)',
      'مدقق لتقارير الضرائب (استخدام غير محدود)',
      'مولد QR والباركود (استخدام غير محدود)',
      'لوحة تحكم كونكتو (تحليلات المبيعات والمخزون) - استخدام غير محدود',
    ],
    'proCreditsNote': 'توفر الباقة 1700 نقطة من الرصيد، الاستخدامات الموضحة هي توزيع مقترح للرصيد، ويمكنك استخدامه بحرية بين الأدوات المتاحة بما يناسب احتياجات أعمالك.',

    // Custom Plan
    'customTitle': 'صمّم باقتك',
    'customDesc': 'صمّم باقتك',
    'customSubdesc': 'اختر الأدوات وحدود الاستخدام التي تناسب طبيعة أعمالك، وادفع فقط مقابل ما تحتاج إليه.',
    'customPlanHeaderTitle': 'صمّم باقتك',
    'customPlanHeaderSubtitle': 'اختر استخدامك',
    'customPlanHeaderDesc': 'حدد عدد مرات الاستخدام التي تحتاجها لكل أداة، وسنحسب لك الرصيد المطلوب والسعر تلقائيًا.',
    'customUnitGeneric': 'استخدام',
    'customToolStudio': 'كونكتو ستوديو',
    'customUnitStudio': 'صفحات منتج',
    'customToolAlpha': 'ألفا',
    'customUnitAlpha': 'صورة',
    'customToolLeo': 'ليو',
    'customUnitLeo': 'عملية إنشاء محتوى',
    'customToolEmma': 'إيما',
    'customUnitEmma': 'استفسارًا',
    'customToolBekam': 'بكام',
    'customUnitBekam': 'عملية متابعة لأسعار المنافسين',
    'customToolEhsably': 'احسبلي',
    'customToolSalesLeads': 'فرص البيع',
    'customToolTaxAuditor': 'مدقق لتقارير الضرائب',
    'customToolQR': 'مولد QR والباركود',
    'customToolDashboard': 'لوحة تحكم كونكتو',
    'customToolManualEdit': 'التعديل اليدوي للصور',
    'customFreeUnlimited': 'استخدام غير محدود — مجانًا',
    'customFreeIncludedTitle': 'أدوات مجانية غير محدودة متضمنة:',
    'customTotalCreditsLabel': 'إجمالي الرصيد المطلوب',
    'customPriceLabel': 'السعر لمدة 30 يومًا',
    'customSaleBanner': 'عرض لفترة محدودة على الباقة المخصصة',
    'customSaleBadge': 'خصم 20%',
    'customOriginalPriceLabel': 'السعر السابق',
    'customCreditUnit': 'نقطة',
    'customNote': 'يمكنك استخدام الرصيد الذي تحصل عليه بحرية بين جميع الأدوات، والأرقام التي اخترتها أعلاه تُستخدم فقط لحساب الرصيد المقترح لاحتياجاتك.',
    'customStartBtn': 'ابدأ الآن',
    'customFeaturesList': [
      'رصيد كونكتو ستوديو',
      'رصيد ألفا',
      'رصيد ليو',
      'استخدام احسبلي',
      'استخدام مولد QR والباركود',
      'استخدام فرص البيع',
      'استخدام مدقق لتقارير الضرائب',
      'استخدام إيما',
      'استخدام بكام',
      'صلاحيات لوحة تحكم كونكتو',
      'جلسات التدريب والاستشارات',
      'عدد المستخدمين',
    ],
    'customStartNow': 'ابدأ باقتك المخصصة',

    // Free Benefits
    'benefitsHeading': 'جميع باقات كونكتو تتضمن مزايا مجانية',
    'benefitsSubheading': 'اشترك في أي باقة من كونكتو واستفد من مجموعة من الخدمات المجانية التي تساعدك على الانطلاق وإدارة أعمالك بكفاءة.',
    'benefitsList': [
      'تكامل عبر واجهات API مع منصات التجارة الإلكترونية',
      'الوصول إلى قاعدة بيانات مورّدين موثوقين',
      'جلسة تدريب على منصات التجارة الإلكترونية',
      'استشارة مجانية مع مدقق ضريبي',
      'الوصول إلى فرص البيع على منصات التجارة الإلكترونية',
      'استشارة مجانية مع خبير إدارة حسابات المتاجر الإلكترونية',
    ],

    // Managed Services
    'managedHeading': 'هل تحتاج إلى أكثر من مجرد منصة؟',
    'managedSubheading': 'دع خبراء إدارة الحسابات في كونكتو يديرون متجرك نيابةً عنك',
    'managedTitle': 'خدمات إدارة الحسابات',
    'managedBody': 'صُممت خدمة إدارة الحسابات لتناسب حجم أعمالك، وعدد المنصات التي تبيع من خلالها، وحجم عملياتك الشهرية.\nسواء كنت تبيع على منصة واحدة أو عدة منصات، وتمتلك العشرات أو الآلاف من المنتجات، يقوم فريق كونكتو ببناء خطة تشغيل تناسب احتياجات نشاطك التجاري.',
    'managedServicesList': [
      'إنشاء وإعداد حسابات البائعين',
      'تحسين صفحات المنتجات وتهيئتها لمحركات البحث (Marketplace SEO)',
      'إدارة الطلبات',
      'إدارة المرتجعات',
      'إدارة الحملات الإعلانية',
      'وضع استراتيجيات نمو المبيعات',
      'تقارير أداء شهرية',
      'مدير حساب مخصص',
      'إدارة الحسابات عبر عدة منصات',
      'دعم غير محدود لإدارة كتالوج المنتجات',
    ],
    'getCustomQuote': 'تواصل معنا الآن',

    // FAQ Section
    'faq': 'الأسئلة الشائعة',
    'faqSubheading': 'أسئلة متكررة',
    'pricingFaqs': [
      { q: 'كيف تعمل أرصدة أدوات منصة كونكتو (AI Credits)؟', a: 'تتضمن كل باقة عددًا من النقاط، ويمكن استخدامها بحرية بين أدوات منصة كونكتو وفقًا لاحتياجات أعمالك.' },
      { q: 'هل يمكنني تخصيص باقتي؟', a: 'نعم، يمكنك تصميم باقة مخصصة بناءً على المنصات التي تعمل عليها، وعدد المنتجات، والخدمات التي تحتاجها.' },
      { q: 'ماذا تتضمن الباقة؟', a: 'تشمل الباقة إمكانية الوصول إلى أدوات كونكتو المدعومة بالذكاء الاصطناعي، ولوحة التحليلات، بالإضافة إلى جميع المزايا الخاصة بالباقة التي اخترتها.' },
      { q: 'هل يمكنني ترقية أو تغيير الباقة؟', a: 'نعم، يمكنك ترقية أو تخفيض باقتك في أي وقت بما يتناسب مع نمو أعمالك.' },
      { q: 'هل تتوفر تجربة مجانية؟', a: 'نعم، يمكنك بدء تجربة مجانية للتعرف على منصة كونكتو وأدواتها قبل الاشتراك.' },
      { q: 'هل يتم ترحيل أرصدة الباقات غير المستخدمة؟', a: 'لا، تنتهي صلاحية الأرصدة غير المستخدمة مع انتهاء دورة الفوترة.' },
      { q: 'ما الفرق بين منصة كونكتو وخدمة إدارة الحسابات؟', a: '• منصة كونكتو تمنحك أدوات ذكية تساعدك على إدارة أعمالك بنفسك باستخدام الذكاء الاصطناعي.\n• أما خدمة إدارة الحسابات فتوفر لك فريقًا متخصصًا يتولى إدارة عمليات متجرك الإلكتروني وحساباتك على منصات التجارة الإلكترونية نيابةً عنك.' },
      { q: 'أي باقة تناسب نشاطي؟', a: 'تم تصميم الباقات الأساسية، الاحترافية، والمخصصة لتناسب مختلف أحجام الأعمال، ويساعدك فريقنا في اختيار الباقة الأنسب وفقًا لاحتياجاتك وأهدافك.' },
    ],

    // Closing CTA
    'closingHeading': 'ابدأ إدارة أعمالك بذكاء مع منصة كونكتو',
    'closingBody': 'سواء كنت تستعد لإطلاق أول منتج، أو تدير آلاف الطلبات يوميًا، تمنحك منصة كونكتو الأدوات المدعومة بالذكاء الاصطناعي، والتحليلات الذكية، والدعم المتخصص الذي تحتاجه لتنمية أعمالك بثقة.',
    'signupNow': 'ابدأ الآن',

    // Platform Page (Next.js /service/platform)
    'heroBadge': 'منصة كونكتو',
    'heroTitle1': 'منصة واحدة...',
    'heroTitle2': 'وفرص نمو لا حدود لها',
    'heroPara1': 'منصة متكاملة تساعدك على إدارة تجارتك عبر مختلف منصات التجارة الإلكترونية من مكان واحد، بدءً من إنشاء المنتجات وإدارة المتاجر، وصولًا إلى الدعم المتخصص وتحليل الأداء لتنمية مبيعاتك.',
    'heroPara2': '',
    'heroCta1': 'ابدأ التجربة المجانية',
    'heroCta2': 'تعرف علي المنصة',

    'toolsHeading': 'طوّر أعمالك مع أدوات ذكية مصممة لبائعي التجارة الإلكترونية',
    'ctaCardTitle': 'أدوات جديدة قريباً',
    'ctaCardDesc': 'إضافات جديدة في الطريق',

    'toolStudioName': 'كونكتو ستوديو',
    'toolStudioDesc': 'أنشئ صفحات منتجات متكاملة.',
    'toolStudioDoes1': 'إنشاء صفحات منتجات متكاملة.',
    'toolStudioDoes2': 'إنشاء صور ومحتوى المنتجات بالذكاء الاصطناعي.',
    'toolStudioDoes3': 'تعبئة بيانات المنتجات تلقائيًا وفق متطلبات المنصات.',
    'toolStudioDoes4': 'احتساب رسوم البيع وتقدير الأرباح.',
    'toolStudioDoes5': 'النشر المباشر على المنصات.',
    'toolStudioGet1': 'إطلاق المنتجات بسرعة تصل إلى 5 أضعاف.',
    'toolStudioGet2': 'تقليل ساعات العمل اليدوي.',
    'toolStudioGet3': 'نشر صفحات منتجات احترافية وخالية من الأخطاء.',
    'toolStudioGet4': 'إدارة رحلة المنتج كاملة من الإنشاء حتى النشر.',

    'toolAlphaName': 'ألفا',
    'toolAlphaDesc': 'أنشئ صورًا احترافية لمنتجاتك.',
    'toolAlphaDoes1': 'إنشاء صور احترافية جاهزة للنشر',
    'toolAlphaDoes2': 'إنشاء صور للمنتج في الطبيعة',
    'toolAlphaDoes3': 'إنشاء صور للمنتج بخلفية بيضاء',
    'toolAlphaDoesDetail': 'إنشاء صور للمنتج بالتفاصيل.',
    'toolAlphaDoes4': 'إزالة الخلفيات الغير مرغوبة.',
    'toolAlphaGet1': 'صور احترافية تعزز هوية منتجاتك.',
    'toolAlphaGet2': 'زيادة فرص جذب العملاء وتحسين معدلات التحويل.',
    'toolAlphaGet3': 'صور متوافقة مع معايير منصات التجارة الإلكترونية.',
    'toolAlphaGet4': 'توليد الصور في ثوانٍ دون الحاجة لجلسات تصوير مكلفة.',

    'toolLeoName': 'ليو',
    'toolLeoDesc': 'أنشئ محتوى احترافيًا يحسن ظهور منتجاتك.',
    'toolLeoDoes1': 'إنشاء عناوين ووصف للمنتج',
    'toolLeoDoes2': 'إنشاء نقاط تعريفية وكلمات مفتاحية.',
    'toolLeoDoes3': 'إنشاء محتوى باللغتين العربية والإنجليزية.',
    'toolLeoDoes4': 'تحسين المحتوى بما يتوافق مع محركات البحث ومتطلبات المنصات.',
    'toolLeoGet1': 'إنشاء المحتوى في وقت أقل.',
    'toolLeoGet2': 'صفحات منتجات أكثر احترافية.',
    'toolLeoGet3': 'زيادة ظهور منتجاتك في نتائج البحث.',
    'toolLeoGet4': 'تحسين تجربة العملاء وزيادة التفاعل.',

    'toolEmmaName': 'إيما',
    'toolEmmaDesc': 'أحصل علي إجابات لاستفساراتك عن التجارة الإلكترونية.',
    'toolEmmaDoes1': 'دعم البائعين في العمليات اليومية.',
    'toolEmmaDoes2': 'الإجابة الفورية على استفسارات التجارة الإلكترونية.',
    'toolEmmaDoes3': 'توفير المعلومات والإرشادات الرسمية الخاصة بالمنصات.',
    'toolEmmaGet1': 'الحصول علي الدعم في أي وقت.',
    'toolEmmaGet2': 'تجنب مخالفات سياسات المنصات.',
    'toolEmmaGet3': 'توفير الوقت في البحث عن المعلومات.',
    'toolEmmaGet4': 'اتخاذ قرارات مبنية على معلومات دقيقة.',

    'toolDashboardName': 'لوحة التحكم',
    'toolDashboardDetailName': 'لوحة تحكم شاملة',
    'toolDashboardDesc': 'تابع المبيعات، والمخزون، وأداء متجرك من خلال لوحة تحكم ذكية.',
    'toolDashboardDoes1': 'عرض تحليلات وتقارير لحظية.',
    'toolDashboardDoes2': 'متابعة المبيعات والمخزون والطلبات.',
    'toolDashboardDoes3': 'مراقبة أداء متاجرك على مختلف المنصات.',
    'toolDashboardGet1': 'قرارات أسرع وأكثر دقة.',
    'toolDashboardGet2': 'رؤية شاملة لأداء أعمالك.',
    'toolDashboardGet3': 'لوحة تحكم موحدة لجميع المنصات.',

    'toolE7seblyName': 'احسبلي',
    'toolE7seblyDesc': 'احسب رسوم المنصات وتكاليف الشحن، وصافي الأرباح المتوقعة.',
    'toolE7seblyDoes1': 'احتساب رسوم المنصات.',
    'toolE7seblyDoes2': 'تقدير تكاليف الشحن.',
    'toolE7seblyDoes3': 'حساب الأرباح المتوقعة قبل البيع.',
    'toolE7seblyGet1': 'تسعير المنتجات بثقة.',
    'toolE7seblyGet2': 'تجنب التكاليف غير المتوقعة.',
    'toolE7seblyGet3': 'معرفة صافي الربح قبل نشر المنتج.',

    'toolBekamName': 'بكام',
    'toolBekamDesc': 'تابع أسعار المنافسين واتجاهات التسعير علي المنصات.',
    'toolBekamDoes1': 'متابعة أسعار المنافسين.',
    'toolBekamDoes2': 'تحليل اتجاهات التسعير.',
    'toolBekamDoes3': 'مراقبة سجل تغيرات الأسعار.',
    'toolBekamGet1': 'زيادة هامش الربح.',
    'toolBekamGet2': 'تحسين استراتيجية التسعير.',
    'toolBekamGet3': 'الحفاظ على قدرتك التنافسية.',

    'toolQRName': 'مولد الرمز والـ QR',
    'toolQRDesc': 'أنشئ أكواد QR وباركود بسهولة وجاهزة للاستخدام.',
    'toolQRDoes1': 'إنشاء أكواد QR.',
    'toolQRDoes2': 'إنشاء باركود متوافق مع متطلبات المنصات.',
    'toolQRGet1': 'إدارة أسهل للمخزون.',
    'toolQRGet2': 'إعداد المنتجات بسرعة.',
    'toolQRGet3': 'أكواد جاهزة للنشر على المنصات.',

    'toolSalesName': 'فرص البيع',
    'toolSalesDesc': 'اكتشف فرص بيع جديدة ومنتجات واعدة لتنمية أعمالك.',
    'toolSalesDoes1': 'تحديد فرص البيع في الأسواق.',
    'toolSalesDoes2': 'تحليل الطلب واتجاهات السوق.',
    'toolSalesDoes3': 'اكتشاف المنتجات ذات الفرص الأعلى.',
    'toolSalesGet1': 'تقليل وقت البحث عن المنتجات.',
    'toolSalesGet2': 'اتخاذ قرارات بيع مبنية على البيانات.',
    'toolSalesGet3': 'الوصول إلي المنتجات الرابحة بسرعة.',

    'toolSellName': 'بيع معانا',
    'toolSellDesc': 'استفد من خبرات فريق كونكتو لتوسيع أعمالك على منصات التجارة الإلكترونية.',
    'toolSellDoes1': 'دعم التوسع في منصات جديدة.',
    'toolSellDoes2': 'الاستفادة من خدمات إدارة الحسابات.',
    'toolSellDoes3': 'التواصل مع خبراء التجارة الإلكترونية.',
    'toolSellGet1': 'التوسع بثقة.',
    'toolSellGet2': 'نمو أسرع لأعمالك.',
    'toolSellGet3': 'دعم تشغيلي احترافي.',

    'toolTaxName': 'مدقق',
    'toolTaxDesc': 'احسب الضرائب بدقة وسرعة لدعم قراراتك المالية.',
    'toolTaxDoes1': 'تقدير الضرائب المستحقة.',
    'toolTaxDoes2': 'حساب الالتزامات الضريبية.',
    'toolTaxDoes3': 'دعم التخطيط المالي.',
    'toolTaxGet1': 'تبسيط إعداد الضرائب.',
    'toolTaxGet2': 'حسابات أكثر دقة.',
    'toolTaxGet3': 'تخطيط مالي أفضل.',

    'toolConsultantName': 'احجز خبير',
    'toolConsultantDesc': 'تواصل مع خبراء التجارة الإلكترونية للحصول على استشارة مخصصة.',
    'toolConsultantDoes1': 'جلسة مع أحد خبراء التجارة الإلكترونية.',
    'toolConsultantDoes2': 'مراجعة أداء متجرك.',
    'toolConsultantDoes3': 'إعداد خطة نمو تناسب أعمالك.',
    'toolConsultantGet1': 'خطة عمل واضحة.',
    'toolConsultantGet2': 'تسريع نمو أعمالك.',
    'toolConsultantGet3': 'توصيات عملية من خبراء متخصصين.',

    'toolVendorName': 'سوق الموردين',
    'toolVendorDesc': 'تواصل مع موردين وشركاء موثوقين لتوسيع شبكة أعمالك.',
    'toolVendorDoes1': 'الوصول إلى موردين موثوقين.',
    'toolVendorDoes2': 'التواصل مع موردين معتمدين.',
    'toolVendorDoes3': 'مقارنة الموردين من حيث الجودة والأسعار.',
    'toolVendorGet1': 'شبكة موردين موثوقة.',
    'toolVendorGet2': 'قرارات شراء أفضل.',
    'toolVendorGet3': 'شراكات تجارية أقوى.',

    'toolTrainingName': 'احجز تدريب',
    'toolTrainingDesc': 'طوّر مهاراتك في التجارة الإلكترونية من خلال جلسات تدريبية مع خبرائنا.',
    'toolTrainingDoes1': 'جلسات تدريب متخصصة.',
    'toolTrainingDoes2': 'الاستفادة من خبرات المتخصصين.',
    'toolTrainingDoes3': 'تعلم أفضل الممارسات على منصات التجارة الإلكترونية.',
    'toolTrainingGet1': 'تنمية أعمالك بثقة.',
    'toolTrainingGet2': 'مواكبة أحدث التغيرات في السوق.',
    'toolTrainingGet3': 'تطوير مهاراتك في التجارة الإلكترونية.',

    'howItWorksBadge': 'كيف تعمل المنصة',
    'howItWorksSubtitle': '',
    'howItWorksStep1Title': 'أنشئ حسابك وسجل الدخول',
    'howItWorksStep1Desc': 'أنشئ حسابك باستخدام البريد الإلكتروني وسجل الدخول إلى منصة كونكتو.',
    'howItWorksStep2Title': 'اربط منصات التجارة الإلكترونية الخاصة بك',
    'howItWorksStep2Desc': 'اربط أمازون، نون، جوميا، ترينديول والمزيد في بضع نقرات. إعداد لمرة واحدة، ومزامنة دائمة.',
    'howItWorksStep3Title': 'شاهد جميع بياناتك في لوحة تحكم واحدة',
    'howItWorksStep3Desc': 'المبيعات، الطلبات، المخزون، والأداء — كل منصة في عرض واحد نظيف. لا مزيد من التنقل بين المنصات.',
    'howItWorksStep4Title': 'استفد من أدوات الذكاء الاصطناعي للنمو بشكل أسرع',
    'howItWorksStep4Desc': 'رؤى ذكية، توقعات اتجاهات، وتوصيات قابلة للتنفيذ مدعومة بالذكاء الاصطناعي — لدفع أعمالك قدماً كل يوم.',
    'howItWorksStep5Title': 'استمتع بالتحكم المطلق في كل منصة',
    'howItWorksStep5Desc': 'أدر، قارن، وتخذ إجراءات عبر جميع متاجرك من مكان واحد. هذا هو شعور إدارة أعمال التجارة الإلكترونية الحديثة.',

    'section3Subtitle': 'أدوات ذكية صُممت لتبسيط عملياتك اليومية وتسريع نمو أعمالك على منصات التجارة الإلكترونية',
    'whatItDoes': 'كيف يساعدك',
    'toolEmmaWhatItDoes': 'ما تقدمه',
    'toolDashboardWhatItDoes': 'كيف تعمل',
    'toolE7seblyWhatItDoes': 'ماذا توفّر لك؟',
    'toolBekamWhatItDoes': 'ماذا يقدّم لك؟',
    'toolTaxWhatItDoes': 'كيف تساعدك',
    'whatYouGet': 'النتائج التي تحققها',
    'startFreeTrial': 'ابدأ تجربتك المجانية',

    'marketplaceBadge': 'التغطية السوقية',
    'marketplaceHeading': 'التغطية السوقية',
    'marketplaceSubheading': 'وسعّ أعمالك علي منصات التجارة الإلكترونية',
    'marketplaceBody': 'تتكامل منصة كونكتو مع أكبر منصات التجارة الإلكترونية في مصر، والسعودية، والإمارات، وتركيا، لتمنحك مكانًا واحدًا لإنشاء المنتجات، وإدارة متجرك، ومتابعة الأداء، وتنمية أعمالك بسهولة.',
    'integratedWith': 'المنصات المدعومة',

    'ctaHeading': 'كل ما تحتاجه لتنمية أعمالك في مكان واحد',
    'ctaHeadingBase': 'كل ما تحتاجه لتنمية أعمالك ',
    'ctaHeadingHighlight': 'في مكان واحد',
    'ctaBody': 'سواء كنت تطلق أول منتج لك أو تدير آلاف المنتجات عبر عدة منصات، توفر لك كونكتو منصة متكاملة، وتحليلات ذكية، ودعم متخصص، لتساعدك على إدارة أعمالك بكفاءة وتحقيق نمو أسرع.',
    'ctaBtn1': 'ابدأ تجربتك المجانية',
    'ctaBtn2': 'احجز استشارة',

    'faqTitle': 'الأسئلة الشائعة',
    'faqSubtitle': 'أسئلة متكررة',
    'faq1Q': 'ما هي منصة كونكتو؟',
    'faq1A': 'منصة كونكتو هي منصة متكاملة مدعومة بالذكاء الاصطناعي، تساعد البائعين على إنشاء صفحات المنتجات، وإدارة عمليات التجارة الإلكترونية، وتحليل الأداء، وتنمية المبيعات من خلال لوحة تحكم موحدة.',
    'faq2Q': 'ما الأدوات المتوفرة داخل المنصة؟',
    'faq2A': 'تضم المنصة مجموعة متكاملة من الأدوات، تشمل كونكتو ستوديو، ألفا، ليو، احسبلي، بكام، لوحة تحكم متكاملة، بالإضافة إلى أدوات أخرى تدعم مختلف مراحل إدارة وتنمية أعمالك.',
    'faq3Q': 'هل يمكنني إدارة أكثر من منصة تجارة إلكترونية؟',
    'faq3A': 'نعم، يمكنك ربط حساباتك على مختلف المنصات وإدارة المنتجات، والمخزون، والطلبات، والمبيعات، والتحليلات من خلال لوحة تحكم مركزية واحدة.',
    'faq4Q': 'هل منصة كونكتو مناسبة للمبتدئين؟',
    'faq4A': 'بالتأكيد. سواء كنت تطلق أول منتج لك أو تدير متجرًا إلكترونيًا قائمًا، توفر كونكتو الأدوات والإرشادات التي تساعدك في كل مرحلة من مراحل نمو أعمالك.',
    'faq5Q': 'هل تدعم المنصة اللغتين العربية والإنجليزية؟',
    'faq5A': 'نعم، تدعم أدوات Connecto إنشاء المحتوى وتقديم المساعدة باللغتين العربية والإنجليزية بما يتناسب مع احتياجات البائعين في مختلف الأسواق.',
    'faq6Q': 'هل يمكن لفريق العمل استخدام المنصة؟',
    'faq6A': 'نعم، صُممت منصة كونكتو لتناسب الأفراد، والفرق المتنامية، والشركات، مع إمكانية التعاون وإدارة الأعمال بكفاءة من خلال منصة واحدة.',

    // About Page (Next.js /about)
    'aboutBadge': 'من نحن',
    'aboutTitle': 'نمكن البائعين. نربط الأسواق. نقود النمو.',
    'aboutBody': 'تم بناء كونكتو لتبسيط عمليات التجارة الإلكترونية من خلال الجمع بين التكنولوجيا المدعومة بالذكاء الاصطناعي وخدمات الأسواق الخبيرة. نحن نساعد الشركات على إدارة أعمالها وتحسينها وتنميتها عبر أهم الأسواق في المنطقة من خلال نظام بيئي ذكي واحد.',

    'storyTitle': 'قصتنا',
    'storyBody1': 'مع نمو أعمال الأسواق، تصبح إدارة المنصات والعمليات والمهام اليومية المتعددة أكثر تعقيداً. ابتكرنا كونكتو لتغيير ذلك.',
    'storyBody2': 'من خلال الجمع بين التكنولوجيا المدعومة بالذكاء الاصطناعي وإدارة الحسابات الخبيرة، تجمع كونكتو كل ما يحتاجه البائعون في نظام بيئي ذكي واحد، مما يساعد الشركات على تبسيط العمليات واتخاذ قرارات أكثر ذكاءً والنمو عبر أهم الأسواق في المنطقة.',

    'missionTitle': 'مهمتنا',
    'missionBody': 'تمكين بائعي التجارة الإلكترونية بالتكنولوجيا الذكية والتوجيه الخبير والحلول المبنية على البيانات التي تبسط العمليات وتسرع النمو.',
    'visionTitle': 'رؤيتنا',
    'visionBody': 'أن نصبح شريك النمو الموثوق والبنية التحتية الذكية وراء كل أعمال تجارة إلكترونية ناجحة في منطقة الشرق الأوسط وشمال أفريقيا.',

    'valuesBadge': 'قيمنا الأساسية',
    'valuesTitle': 'قيمنا الأساسية',
    'value1Title': 'العميل أولاً',
    'value2Title': 'النمو المستمر',
    'value3Title': 'الشفافية والثقة',
    'value4Title': 'الابتكار بهدف',

    'whyTitle': 'لماذا تختار الشركات كونكتو',
    'whySubtitle': '',
    'whyCard1Title': 'منصة مدعومة بالذكاء الاصطناعي',
    'whyCard1Body': 'أتمتة إنشاء المنتجات والتسعير والتحليلات وعمليات الأسواق.',
    'whyCard2Title': 'إدارة حسابات خبيرة',
    'whyCard2Body': 'متخصصون مخصصون في الأسواق يديرون عملياتك اليومية ونموك.',
    'whyCard3Title': 'خبرة متعددة الأسواق',
    'whyCard3Body': 'بع عبر أمازون، نون، جوميا، ترينديول، نمشي وكينز.',
    'whyCard4Title': 'نمو مدعوم بالبيانات',
    'whyCard4Body': 'اتخذ قرارات أكثر ذكاءً مع تحليلات فورية ورؤى أعمال.',

    'profileTitle': 'هل تريد معرفة المزيد عن كونكتو؟',
    'profileBody': 'حمّل ملف الشركة لاستكشاف خدماتنا ومنصتنا وقصص نجاحنا وخبرتنا في الأسواق.',
    'profileBtn': 'تحميل ملف الشركة',

    'impactTitle': 'أثرنا',
    'stat1Value': '2,000+',
    'stat1Label': 'بائع مدعوم',
    'stat2Value': '500%+',
    'stat2Label': 'نمو في الإيرادات',
    'stat3Value': '20×',
    'stat3Label': 'نمو أسرع للأعمال',
    'stat4Value': '6+',
    'stat4Label': 'تكاملات أسواق',
    'impactBtn': 'ابدأ رحلة نمو أعمالك مع كونكتو الآن',

    'aboutClosingTitle': 'لننمي أعمالك في الأسواق',
    'aboutClosingBody': 'احجز استشارة مجانية مع خبراء الأسواق لدينا واكتشف كيف يمكن لكونكتو مساعدتك في النمو عبر أمازون، نون، جوميا، ترينديول، نمشي وكينز.',
    'aboutClosingCheck1': 'استشارة أسواق مجانية',
    'aboutClosingCheck2': 'استراتيجية نمو مخصصة',
    'aboutClosingCheck3': 'منصة واحدة. سير عمل واحد.',
    'aboutConsultBtn': 'احجز استشارتك المجانية',
    'howItWorksTitle': 'كيف يعمل',
    'howItWorksMainTitle': 'انتقل من الصفر إلى التحكم الكامل في خمس خطوات',
    'step1Title': 'أنشئ حسابك وسجل الدخول',
    'step1Desc': 'إنشئ حسابك بإستخدام الاميل و سجل الدخول الى منصة كونكتو',
    'step1Badge': 'يستغرق أقل من دقيقتين',
    'step2Title': 'اربط منصات التجارة الإلكترونية الخاصة بك',
    'step2Desc': 'اربط أمازون، نون، جوميا، ترنديول، شوبيفاي والمزيد في بضع نقرات. إعداد لمرة واحدة، ومزامنة دائمًا.',
    'step2Badge': 'أمازون · نون · جوميا · ترنديول · شوبيفاي',
    'step3Title': 'شاهد جميع بياناتك في لوحة تحكم واحدة',
    'step3Desc': 'المبيعات، الطلبات، المخزون، والأداء - يتم تجميع كل منصة في عرض واحد نظيف. لا مزيد من التنقل بين المنصات المختلفة.',
    'step3Badge': 'بيانات حية · عرض موحد',
    'step4Title': 'استفد من أدوات الذكاء الاصطناعي للنمو بشكل أسرع',
    'step4Desc': 'رؤى ذكية، وتوقعات الاتجاهات، وتوصيات قابلة للتنفيذ مدعومة بالذكاء الاصطناعي - تم بناؤها لدفع عملك إلى الأمام كل يوم.',
    'step4Badge': 'رؤى مدعومة بالذكاء الاصطناعي',
    'step5Title': 'استمتع بالتحكم المطلق في كل منصة',
    'step5Desc': 'إدارة ومقارنة واتخاذ إجراءات عبر جميع متاجرك من مكان واحد. هذا هو الشعور بإدارة عمل تجاري إلكتروني حديث.',
    'step5Badge': 'مركز التحكم الكامل',

    // Services Section (from website)
    'ourServicesTitle': 'خدماتنا',
    'ourServicesSubtitle': 'تمكين ابتكار التجارة الإلكترونية من خلال خدمات متطورة',
    'service1Title': 'إدارة حساب كاملة',
    'service1Desc': 'تقديم تقارير يومية وأسبوعية، تحسين تقييم البائع، تحسين المحتوى وقوائم المنتجات، العمل على زيادة المبيعات، التركيز على المنتجات الأكثر مبيعاً، إدارة حساب البائع.',
    'service2Title': 'الإعلانات والحملات على المنصات',
    'service2Desc': 'تطوير الحملات الإعلانية، خطة للمراقبة والتشغيل، تقييم الأداء، تعزيز مبيعات الحساب، تقديم تقارير يومية وأسبوعية، تحديثات عبر واتساب.',
    'service3Title': 'إدارة الكتالوج والمحتوى المميز A+',
    'service3Desc': 'إدراج منتجات/وحدات جديدة، تحسين المحتوى إلى A+، تحسين عرض الصور، تعزيز وصف المنتج، التركيز على المنتجات الأكثر مبيعاً.',

    // About Page 
    'aboutSubtitle': 'نبني مستقبل التجارة الإلكترونية',
    
    'aboutStory': 'من نحن',
    'aboutStoryText': 'كونكتو تعمل على مساعدة إدارة الحسابات على منصات التجارة الإلكترونية من خلال توفير جميع الخبرات الممكنة لمساعدة البائعين في تطوير أعمالهم على منصات البيع، بالإضافة إلى زيادة المبيعات المحتملة.',
    'aboutStoryText2': 'نمكّن البائعين من خلال تبسيط إدارة المخزون والكتالوج المعقدة، وتوفير الوصول لرأس المال النمو، وتقديم مجموعة أوسع من خيارات توريد المنتجات.',
    
    'aboutVision': 'الرؤية',
    'aboutVisionText': 'أن نصبح البنية التحتية الذكية التي يعتمد عليها كل بائع إلكتروني لتحقيق نمو أسرع وربحية أعلى بثقة ووضوح.',
    
    'aboutMission': 'المهمة',
    'aboutMissionText': 'تمكين بائعي التجارة الإلكترونية من إدارة وتنمية أعمالهم بكفاءة أعلى عبر أدوات ذكية متكاملة تعتمد على البيانات، وتبسط العمليات، وتدعم اتخاذ القرار السريع والدقيق.',
    
    'aboutOurMessage': 'رسالتنا',
    'aboutOurMessageText': 'تمكين البائعين من اتخاذ قرارات مبنية على بيانات دقيقة لتحقيق أعلى أداء وربحية ممكنة.',
    'aboutValues': 'قيمنا',
    
    'aboutValue1': 'العميل أولاً',
    'aboutValue1Desc': 'نضع احتياجات عملائنا في مقدمة أولوياتنا في كل قرار وكل ميزة',
    
    'aboutValue2': 'القرارات المبنية على البيانات',
    'aboutValue2Desc': 'نعتمد على التحليل الدقيق للبيانات لاتخاذ أفضل القرارات وتحقيق نتائج ملموسة',
    
    'aboutValue3': 'السرعة مع الجودة',
    'aboutValue3Desc': 'نقدم حلولاً سريعة دون التضحية بمعايير الجودة والتميز',
    
    'aboutValue4': 'الشفافية والمصداقية',
    'aboutValue4Desc': 'نؤمن بالشفافية الكاملة مع عملائنا ونبني علاقات قائمة على الثقة',
    
    'aboutValue5': 'التركيز على النتائج',
    'aboutValue5Desc': 'نركز على تحقيق نتائج ملموسة ومؤثرة تساعد عملاءنا على النمو والازدهار',
    
    'aboutValue6': 'التعلم والتطور المستمر',
    'aboutValue6Desc': 'نسعى دائماً للتطور والتعلم ومواكبة أحدث التوجهات في عالم التجارة الإلكترونية',
    
    'aboutStats1': 'رضا العملاء',
    'aboutStats2': 'زيادة الإيرادات',
    'aboutStats3': 'نمو الأعمال',

    // Support Page
    'supportTitle': 'الدعم',
    'supportSubtitle': 'نحن هنا لمساعدتك في كل خطوة',
    'partnershipsSection': 'شركاؤنا',
    'partnershipsDesc': 'نعمل مع أكبر منصات التجارة الإلكترونية لتوفير تجربة متكاملة',
    'faqSection': 'الأسئلة الشائعة',
    'contactSection': 'تواصل معنا',
    'contactDesc': 'نحن متاحون من الأحد إلى الخميس من 9 صباحاً حتى 5 مساءً ويمكنك التواصل معنا في أي وقت',
    'contactName': 'الاسم',
    'contactEmail': 'البريد الإلكتروني',
    'contactCountry': 'دولة الشركة',
    'contactPhoneCountry': 'دولة رقم الهاتف',
    'contactSelectCountry': 'اختر الدولة',
    'contactInvalidPhone': 'يرجى إدخال رقم هاتف صحيح',
    'contactMobile': 'رقم الجوال',
    'contactSubject': 'الموضوع',
    'contactMessage': 'رسالتك',
    'contactSend': 'إرسال الرسالة',
    'supportSubmitting': 'جاري الإرسال...',
    'supportSuccessTitle': 'تم إرسال رسالتك بنجاح!',
    'supportSuccessMessage': 'شكراً لتواصلك معنا. سيقوم فريق الدعم بمراجعة رسالتك والرد عليك في أقرب وقت.',
    'supportSubmitAnother': 'إرسال رسالة أخرى',
    'supportErrorMessage': 'حدث خطأ أثناء إرسال الرسالة. يرجى المحاولة مرة أخرى.',
    'consultFormName': 'الاسم بالكامل',
    'consultFormEmail': 'البريد الإلكتروني',
    'consultFormPhone': 'رقم الهاتف',
    'consultFormMessage': 'الرسالة',
    'consultButton': 'إرسال الطلب',
    'consultSuccess': 'تم استلام طلبك. سيتواصل معك فريقنا.',

    'phoneLabel': 'الهاتف',
    'emailLabel': 'البريد الإلكتروني',
    'addressLabel': 'العنوان',

    // Solutions Page
    'solutionsPageTitle': 'حلولنا الذكية',
    'solutionsPageSubtitle': 'مجموعة متكاملة من الأدوات الذكية المصممة لنمو تجارتك الإلكترونية',
    'learnMore': 'اعرف المزيد',

    // About Platform Page 
    'aboutPlatform': 'عن منصتنا',
    'aboutPlatformTitle': 'أطلق تجارتك الإلكترونية لمستوى أعلى',
    'aboutPlatformSubtitle': 'كل الأدوات التي تحتاجها كبائع… في مكان واحد.',
    
    'painPoint1': 'هل تضيع وقتك بين منصات متعددة؟',
    'painPoint2': 'هل تشعر أن قراراتك تعتمد على التخمين؟',
    'painPoint3': 'هل تبيع، لكن لا تعرف أين تذهب أرباحك؟',
    'solutionHere': 'الحل الأفضل هنا:',
    'solutionDesc': 'منظومتنا الذكية تجمع لك الإدارة + التحليل + التسويق + التسعير + الامتثال في نظام واحد مصمم خصيصًا لبائعين:',
    
     // Connecto Feature
    'connectoFeature': 'كونكتو 🔗',
    'connectoDesc': 'سيطر على كل حساباتك من شاشة واحدة',
    'connectoBenefit1': 'توقف عن تسجيل الدخول والخروج بين المنصات.',
    'connectoBenefit2': 'توقف عن مقارنة التقارير يدويًا.',
    'connectoBenefit3': 'منصة كونكتو تمنحك رؤية كاملة لكل حساباتك في لوحة تحكم ذكية.',
    'connectoResult': 'ماذا ستحصل؟',
    'connectoResultDesc': 'مقارنة فورية بين أداء المنصات • تحليل نقاط القوة والضعف • متابعة يومية دقيقة للمبيعات • قرارات أسرع مبنية على بيانات حقيقية',  // تم دمجها هنا
    'connectoFinalResult': 'النتيجة: زيادة أرباحك لأنك أخيرًا ترى الصورة كاملة.',
    
    
    'pf1Title': 'ألفا 🎨',
    'pf1Subtitle': 'صور احترافية تزيد مبيعاتك خلال دقائق',
    'pf1WhyImportant': 'لماذا مهم؟',  
    'pf1Desc': 'العميل يقرر خلال ثواني. صورتك إما تبيع… أو تُهمل. ألفا يحول صور منتجاتك العادية إلى صور احترافية جذابة بالذكاء الاصطناعي:',
    'pf1c1': 'صور مطابقة لمعايير المنصات',
    'pf1c2': 'خلفيات نظيفة أو إبداعية',
    'pf1c3': 'بدون جلسات تصوير مكلفة',
    'pf1c4': 'إطلاق أسرع للمنتجات',
    'pf1Note': 'النتيجة: صور أفضل = معدل نقر أعلى = مبيعات أكثر',
    
    'pf2Title': 'ليو ✍️',
    'pf2Subtitle': 'محتوى يجعل العميل يقول "أريده الآن"',
    'pf2Desc': 'الوصف السيء يقتل المبيعات. العنوان الضعيف يجعلك غير مرئي. ليو ينشئ لك محتوى عالي التحويل:',
    'pf2c1': 'عناوين متوافقة مع البحث',
    'pf2c2': 'أوصاف مقنعة',
    'pf2c3': 'نقاط بيع قوية تبرز ميزتك التنافسية',
    'pf2Note': 'النتيجة: ظهور أفضل + ثقة أعلى + تحويل أكبر',
    
    'pf3Title': 'إحسبلي 💰',
    'pf3Subtitle': 'لا تطلق منتجًا قبل أن تعرف ربحك الحقيقي',
    'pf3Desc': 'كم مرة بعت منتج واكتشفت أن هامش الربح أقل مما توقعت؟ إحسبلي يحسب لك كل شيء:',
    'pf3c1': 'تكلفة الشراء',
    'pf3c2': 'الشحن والجمارك',
    'pf3c3': 'عمولات المنصات',
    'pf3c4': 'الضرائب',
    'pf3Note': 'النتيجة: تعرف ربحك الصافي قبل أن تبدأ. لا مفاجآت. لا خسائر غير محسوبة.',
    
    'pf4Title': 'بكام 📊',
    'pf4Subtitle': 'اعرف سعر السوق … قبل أن يسبقك منافسك',
    'pf4Desc': 'التسعير العشوائي يعني خسارة مؤكدة. بكام يحلل أسعار المنافسين ويعرض لك:',
    'pf4c1': 'أعلى وأقل ومتوسط سعر',
    'pf4c2': 'حركة الأسعار خلال آخر 3 أشهر',
    'pf4c3': 'اتجاه السوق (ارتفاع أم انخفاض؟)',
    'pf4Note': 'النتيجة: تسعير ذكي = تنافس أقوى + ربح مستدام',
    
    'pf5Title': 'إيما 🤖',
    'pf5Subtitle': 'إجابات فورية لكل أسئلتك حول المنصات',
    'pf5Desc': 'تبحث ساعات عن سياسة أو رسوم معينة؟ إيما تعطيك الإجابة فورًا من المصادر المعتمدة:',
    'pf5c1': 'سياسات',
    'pf5c2': 'رسوم',
    'pf5c3': 'متطلبات القوائم',
    'pf5c4': 'معلومات السوق',
    'pf5Note': 'النتيجة: قرار أسرع = تنفيذ أسرع = نمو أسرع',
    
    'pf6Title': 'مدقق 🧾',
    'pf6Subtitle': 'ضرائبك… بدون صداع',
    'pf6Desc': 'احجز جلسة مع محاسب متخصص في التجارة الإلكترونية وتأكد أن كل شيء مطابق للقوانين:',
    'pf6c1': 'تجنب الغرامات',
    'pf6c2': 'التزام كامل',
    'pf6c3': 'راحة بال',
    'pf6Note': 'النتيجة: امتثال ضريبي كامل',
    
    'pf7Title': 'إحجز خبير 📈',
    'pf7Subtitle': 'تقييم احترافي لحسابك = قفزة في المبيعات',
    'pf7Desc': 'مدير حساب متخصص يحلل أداءك ويعطيك خطة عملية قابلة للتنفيذ. ليس كلامًا نظريًا بل خطوات واضحة لزيادة المبيعات وتحسين ترتيب منتجاتك:',
    'pf7c1': 'خبرة واسعة فى منصات أمازون و نون و ترنديول و جوميا',
    'pf7c2': 'خطة عملية قابلة للتنفيذ',
    'pf7c3': 'تحقيق مبيعات مع تجار تتعدي 300x',
    'pf7Note': 'النتيجة: ارتفاع في المبيعات',
    
    'pf8Title': 'مؤثر 📣',
    'pf8Subtitle': 'وسّع انتشارك بسرعة عبر المؤثرين',
    'pf8Desc': 'الوصول لجمهور مستهدف لم يكن أسهل من قبل:',
    'pf8c1': 'اختيار المؤثر المناسب',
    'pf8c2': 'تسهيل التواصل',
    'pf8c3': 'متابعة نتائج الحملات',
    'pf8Note': 'النتيجة: زيادة وعي = زيادة طلب = زيادة مبيعات',
    
    'pf9Title': 'لماذا نحن مختلفون؟',
    'pf9Subtitle': 'نحن لا نقدم أداة واحدة',
    'pf9Desc': 'نحن نقدم نظام نمو متكامل للبائع:',
    'pf9c1': 'بدلاً من أدوات متفرقة',
    'pf9c2': 'بدلاً من قرارات مبنية على التخمين',
    'pf9c3': 'بدلاً من تضييع وقت',
    'pf9Note': 'النتيجة: رؤية كاملة + قرارات دقيقة + تنفيذ أسرع + نمو مستدام',
    
    'ctaReady': 'جاهز تضاعف نتائجك؟',
    'ctaBenefit1': 'وفّر وقتك',
    'ctaBenefit2': 'زد أرباحك',
    'ctaBenefit3': 'بياناتك تعمل لصالحك',
    'ctaDesc': 'ابدأ اليوم. اجعل بياناتك تعمل لصالحك.',
    'ctaButton': 'جرّب الآن',

    // Partners Page
    'partnersPageTitle': 'الشراكات',
    'partnersPageSubtitle': 'سعداء بالتواصل معكم',
    'partnersPageDescription': 'نؤمن بأن الشراكات القوية هي أساس النجاح. انضم إلى شبكة شركاء كونكتو وكن جزءاً من منظومة تُعيد تشكيل مستقبل التجارة الإلكترونية في المنطقة.',
    'partnerFormTitle': 'تقديم طلب شراكة',
    'partnerName': 'الاسم الكامل',
    'partnerEmail': 'البريد الإلكتروني',
    'partnerCountry': 'الدولة',
    'partnerSelectCountry': 'اختر الدولة',
    'partnerMobile': 'رقم الجوال',
    'partnerMessage': 'رسالتك',
    'partnerMessagePlaceholder': 'أخبرنا عن شركتك وكيف يمكننا التعاون معاً...',
    'partnerSubmit': 'إرسال الطلب',
    'partnerSubmitting': 'جاري الإرسال...',
    'partnerSuccessTitle': 'تم إرسال طلبك بنجاح!',
    'partnerSuccessMessage': 'شكراً لاهتمامك بالشراكة معنا. سيقوم فريقنا بمراجعة طلبك والتواصل معك في أقرب وقت.',
    'partnerSubmitAnother': 'تقديم طلب آخر',
    'partnerErrorMessage': 'حدث خطأ أثناء إرسال الطلب. يرجى المحاولة مرة أخرى.',
    'partnerWhyTitle': 'لماذا تصبح شريكاً لكونكتو؟',
    'partnerWhy1Title': 'شبكة واسعة',
    'partnerWhy1Desc': 'وصول مباشر لأكثر من 1000 تاجر نشط عبر المنطقة',
    'partnerWhy2Title': 'نمو متسارع',
    'partnerWhy2Desc': 'فرص إيرادات مشتركة مع نمو يتجاوز 500% سنوياً',
    'partnerWhy3Title': 'دعم متكامل',
    'partnerWhy3Desc': 'فريق متخصص لدعم الشركاء وتحقيق أقصى استفادة من الشراكة',
    'partnerHappy': 'يسعدنا تلقي طلبكم',
    'partnerFormDesc': 'املأ النموذج التالي وسيتواصل معك فريقنا خلال 24 ساعة',

    // Admin Partners Page
    'adminPartnersTitle': 'طلبات الشراكة',
    'adminPartnersSubtitle': 'إدارة ومراجعة طلبات الشراكة المقدمة',
    'adminTotalApplications': 'إجمالي الطلبات',
    'adminNoApplications': 'لا توجد طلبات شراكة حتى الآن',
    'adminColumnName': 'الاسم',
    'adminColumnEmail': 'البريد الإلكتروني',
    'adminColumnCountry': 'الدولة',
    'adminColumnPhone': 'رقم الجوال',
    'adminColumnMessage': 'الرسالة',
    'adminColumnDate': 'تاريخ التقديم',
    'adminColumnStatus': 'الحالة',
    'adminStatusNew': 'جديد',

    // Footer
    'rights': 'جميع الحقوق محفوظة',
    'companyName': 'كونكتو',
    'year': '2025',
    'quickLinks': 'روابط سريعة',
    'contactUs': 'اتصل بنا',
    'email': 'sellers@connecto-me.com',
    'address': 'المبنى رقم 1 - شيل أوت لوتس ماكسيم - الدور الثالث، التجمع الخامس - القاهرة الجديدة - مصر',
    'company': 'الشركة',
    'terms': 'الشروط والأحكام',
    'privacy': 'سياسة الخصوصية',
    'partnerships': 'الشراكات',
    'footerDescription': 'نبسّط إدارة المخزون والكتالوج، ونوفر رأس مال النمو، ونقدم حلولاً محلية، لتمكين البائعين من التوسع بسهولة. انضم إلينا لتبسيط العمليات وزيادة المبيعات بأدوات ذكاء اصطناعي ودعم بأولوية.',

    // Privacy Policy Page
    'privacyPolicy': 'سياسة الخصوصية',
    
    'introTitle': 'مقدمة',
    'introText': 'مرحباً بك في كونكتو. نحن ملتزمون بحماية خصوصيتك والتعامل مع بياناتك بشفافية ووضوح. توضح سياسة الخصوصية هذه كيفية جمع واستخدام وحماية معلوماتك عند استخدام منصة التكامل مع أمازون.',
    
    'dataCollectTitle': 'البيانات التي نجمعها من Amazon SP-API',
    'dataCollectText': 'عند ربط حسابك في أمازون بمنصتنا، نقوم بجمع وتخزين المعلومات التالية فقط (غير قابلة للتعريف الشخصي):',
    'dataCollectItem1': 'بيانات اعتماد البائع (رموز التحديث والوصول المشفرة)',
    'dataCollectItem2': 'معرف البائع (SP-ID)',
    'dataCollectItem3': 'معرفات الأسواق',
    'dataCollectItem4': 'أرقام الطلبات والبيانات المالية للطلبات',
    'dataCollectItem5': 'بيانات المنتجات والمخزون',
    'dataCollectItem6': 'مقاييس المبيعات والأداء',
    
    'dataNotCollectTitle': 'البيانات التي لا نجمعها',
    'dataNotCollectText': 'امتثالاً لسياسة حماية بيانات Amazon SP-API، نحن لا نخزن أو نعالج أي معلومات تعريف شخصية (PII)، بما في ذلك:',
    'dataNotCollectItem1': 'أسماء المشترين',
    'dataNotCollectItem2': 'عناوين البريد الإلكتروني للمشترين',
    'dataNotCollectItem3': 'أرقام هواتف المشترين',
    'dataNotCollectItem4': 'عناوين الشحن',
    'dataNotCollectItem5': 'عناوين الفواتير',
    'dataNotCollectItem6': 'أي معلومات شخصية أخرى للعملاء',
    'dataNotCollectNote': 'جميع المعلومات الشخصية التي ترجعها Amazon SP-API يتم تصفيتها تلقائياً ولا تُحفظ في أنظمتنا.',
    
    'howStoreTitle': 'كيف نخزن بياناتك',
    'howStoreText': 'نحن نأخذ أمان البيانات على محمل الجد ونطبق معايير الحماية:',
    'howStoreItem1': 'جميع رموز التحديث والوصول مشفرة باستخدام AES-256',
    'howStoreItem2': 'بيانات اعتماد قاعدة البيانات مخزنة بشكل آمن ولا تتعرض أبداً',
    'howStoreItem3': 'الوصول إلى بيانات البائع مقصور على عمليات النظام المصرح بها فقط',
    'howStoreItem4': 'جميع اتصالات API تستخدم تشفير HTTPS/TLS',
    'howStoreItem5': 'رموز الوصول تنتهي تلقائياً خلال ساعة ويتم تحديثها حسب الحاجة',
    
    'dataRetentionTitle': 'سياسة الاحتفاظ بالبيانات',
    'dataRetentionText': 'نحتفظ ببياناتك وفقاً للسياسات التالية:',
    'dataRetentionItem1': 'بيانات اعتماد البائع: تُخزن رموز التحديث إلى أجل غير مسمى حتى تقوم بإلغاء الوصول أو حذف حسابك',
    'dataRetentionItem2': 'رموز الوصول: تنتهي الرموز المؤقتة تلقائياً خلال ساعة',
    'dataRetentionItem3': 'بيانات الطلبات والمبيعات: تُخزن طالما أن حسابك نشط لتوفير التحليلات والتقارير',
    'dataRetentionItem4': 'حالات OAuth: تُحذف تلقائياً بعد ساعة أو عند المصادقة بنجاح',
    
    'complianceTitle': 'الامتثال لسياسات أمازون',
    'complianceText': 'منصتنا متوافقة تماماً مع سياسة حماية بيانات Amazon SP-API. نحن:',
    'complianceItem1': 'لا نخزن أو نعالج المعلومات الشخصية للعملاء',
    'complianceItem2': 'نطبق تنقية المعلومات الشخصية الإلزامية في طبقة API',
    'complianceItem3': 'نستخدم تخزيناً آمناً للرموز مع التشفير',
    'complianceItem4': 'نقدم ممارسات شفافة للتعامل مع البيانات',
    'complianceItem5': 'نحترم ملكية البائع للبيانات والتحكم فيها',
    
    'yourRightsTitle': 'حقوقك في البيانات',
    'yourRightsText': 'لديك السيطرة الكاملة على بياناتك:',
    'yourRightsItem1': 'الوصول: عرض جميع البيانات التي جمعناها من حسابك في أمازون من خلال لوحة التحكم',
    'yourRightsItem2': 'الحذف: حذف حسابك وجميع البيانات المرتبطة به فوراً في أي وقت',
    'yourRightsItem3': 'الإلغاء: إلغاء وصولنا إلى حسابك في أمازون في أي وقت عبر Amazon Seller Central',
    'yourRightsItem4': 'التصدير: طلب نسخة من بياناتك بالاتصال بفريق الدعم',
    'yourRightsItem5': 'التصحيح: البيانات متزامنة من أمازون - يجب إجراء أي تصحيحات في Seller Central',
    
    'dataSharingTitle': 'مشاركة البيانات والأطراف الثالثة',
    'dataSharingText': 'نحن لا نبيع أو نؤجر أو نشارك بياناتك مع أطراف ثالثة لأغراض التسويق. يمكن الوصول إلى بياناتك فقط من خلال:',
    'dataSharingItem1': 'أنظمتنا الخلفية الآمنة لتقديم الخدمة',
    'dataSharingItem2': 'خادم خاص افتراضي آمن لاستضافة التطبيق وقاعدة البيانات',
    'dataSharingItem3': 'أنت، من خلال لوحة التحكم وإعدادات حسابك',
    
    'cookiesTitle': 'ملفات تعريف الارتباط والتتبع',
    'cookiesText': 'نستخدم ملفات تعريف الارتباط الأساسية لتشغيل المنصة. بعد موافقتك، قد نستخدم Google Tag Manager وGoogle Ads وContentsquare لقياس أداء الموقع وتحسين تجربتك. يمكنك رفض ملفات تعريف الارتباط الاختيارية، أو تغيير اختيارك بمسح بيانات الموقع من إعدادات المتصفح.',
    
    'securityTitle': 'الإجراءات الأمنية',
    'securityText': 'نطبق إجراءات أمنية شاملة تشمل:',
    'securityItem1': 'تشفير شامل للبيانات الحساسة',
    'securityItem2': 'مراجعات وتحديثات أمنية منتظمة',
    'securityItem3': 'تدفق مصادقة OAuth 2.0 آمن',
    'securityItem4': 'حماية CSRF لجميع عمليات تغيير الحالة',
    'securityItem5': 'تنظيف تلقائي للرموز والحالات منتهية الصلاحية',
    'securityItem6': 'سجلات منقاة لا تتضمن أبداً معلومات حساسة',
    
    'changesTitle': 'تغييرات على هذه السياسة',
    'changesText': 'قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر لتعكس التغييرات في ممارساتنا أو المتطلبات القانونية. سنقوم بإخطارك بأي تغييرات جوهرية عن طريق تحديث تاريخ "آخر تحديث" في أعلى هذه السياسة.',
    
    'contactTitle': 'اتصل بنا',
    'contactText': 'إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه أو ممارسات البيانات لدينا، يرجى الاتصال بنا:',
    'responseTime': 'وقت الرد: خلال ٢٤-٤٨ ساعة',

    // Account Management Page
    'amHeroBadge': 'شريك معتمد من Amazon SPN',
    'amHeroTitle': 'إدارة حسابات المتاجر الإلكترونية',
    'amHeroSubtitle': 'ندير عمليات متجرك.. لتتفرغ لتنمية أعمالك',
    'amHeroBody': 'من إنشاء حسابات البائعين، وتحسين صفحات المنتجات، وإدارة الحملات الإعلانية، إلى متابعة الطلبات والعمليات المالية وتنمية المبيعات، يعمل فريق كونكتو كشريك متخصص لإدارة متجرك عبر أمازون، نون، ترينديول، جوميا، كنز، ونمشي.',
    'amHeroCta': 'احجز استشارة مجانية',
    'amHeroBadgeLink': 'https://sellercentral.amazon.com/gspn/provider-details/Training/ebfe81a2-8a6f-48c9-a921-a560638b57a9?ref_=sc_gspn_trlst_trdt-ebfe81a2&localeSelection=en_US&sellFrom=US&sellIn=US',

    'amRoadmapTitle': 'خطوات رحلتك معنا',
    'amRoadmapStep1': 'تسجيل البائعين',
    'amRoadmapStep2': 'إدارة القوائم والمحتوي',
    'amRoadmapStep3': 'إدارة الطلبات والشئون المالية',
    'amRoadmapStep4': 'إدارة المرتجعات',
    'amRoadmapStep5': 'إدارة الحملات الإعلانية',
    'amRoadmapStep6': 'تنمية المتجر وزيادة المبيعات',

    'amCoverageHeading': 'المنصات المدعومة',
    'amCoverageSubheading': 'وسّع أعمالك عبر أكبر منصات التجارة الإلكترونية',
    'amCoverageBody': 'يُساعدك فريق كونكتو المتخصص في إدارة حسابات المتاجر الإلكترونية على إطلاق متجرك، وإدارة عملياته اليومية، وتحقيق نمو مستدام عبر أكبر منصات التجارة الإلكترونية في المنطقة.',
    'amCoverageCta': 'تعرّف علي جميع المنصات المدعومة',
    'amCoverageRegion': 'يدعم البائعين في مصر، والسعودية، والإمارات العربية المتحدة.',

    'amWhatWeDo': 'كيف نساعدك',
    'amWhatYouGet': 'النتائج التي تحققها',

    'amService1Title': 'تسجيل البائعين',
    'amService1Do': 'نتولى تسجيل وإدارة حسابات البائعين على أمازون، نون، ترينديول، وجوميا، لضمان بداية احترافية وتجهيز متجرك بما يتوافق مع متطلبات كل منصة.',
    'amService1Get': 'تسجيل حساب البائع, تحسين قوائم المنتجات, إدارة مستمرة لأداء الحساب',

    'amService2Title': 'تحسين القوائم والمحتوي',
    'amService2Do': 'ننشئ صفحات منتجات احترافية ونطور المحتوى باستخدام أفضل الممارسات، مع تصميم محتوى A+ يعكس هوية علامتك التجارية ويزيد من معدلات التحويل.',
    'amService2Get': 'إضافة المنتجات, تصميم محتوى A+, إنشاء قوائم جذابة بصريًا, صفحات مهيأة لزيادة المبيعات',

    'amService3Title': 'إدارة الطلبات والشئون المالية',
    'amService3Do': 'نتولى إدارة العمليات اليومية لمتجرك، بدءً من متابعة الطلبات والمدفوعات وحتى العمليات المالية، لضمان سير العمل بكفاءة واستقرار.',
    'amService3Get': 'إدارة الطلبات, متابعة المدفوعات, إدارة العمليات المالية, متابعة أداء المتجر, تحسين الكفاءة التشغيلية',

    'amService4Title': 'إدارة المرتجعات وخدمة العملاء',
    'amService4Do': 'ندير طلبات الإرجاع ونتابع الحالات المتعلقة بالعملاء، بما يضمن تجربة تسوق أفضل ويحافظ على أداء حساب البائع.',
    'amService4Get': 'إدارة المرتجعات, متابعة استفسارات ومشكلات العملاء, تنسيق عمليات الاسترداد, متابعة الحالات مع المنصات, الحفاظ على صحة وأداء حساب البائع',

    'amService5Title': 'إدارة الحملات الإعلانية',
    'amService5Do': 'نخطط ونطلق وندير الحملات الإعلانية على أمازون، نون، ترينديول، وجوميا، مع تحسين الأداء بشكل مستمر لزيادة ظهور منتجاتك، واستهداف العملاء المناسبين، وتحقيق أعلى عائد على الإنفاق الإعلاني.',
    'amService5Get': 'إعداد استراتيجية إعلانية, إدارة الحملات, استهداف الجمهور المناسب, تحسين أداء الحملات, زيادة العائد على الإنفاق الإعلاني',

    'amService6Title': 'تنمية المتجر وزيادة المبيعات',
    'amService6Do': 'نعمل باستمرار على تحسين أداء متجرك، وزيادة ظهور منتجاتك في نتائج البحث، ورفع ترتيبها، ووضع استراتيجيات تساعدك على تحقيق نمو مستدام في المبيعات.',
    'amService6Get': 'تحسين أداء المتجر, رفع ترتيب المنتجات, استراتيجيات لزيادة المبيعات, التوسع في منصات جديدة, نمو مستدام لأعمالك',

    'amWhyHeading': 'لماذا تختار كونكتو؟',
    'amWhyBody': 'على عكس الأدوات التقليدية، تجمع كونكتو بين خبراء متخصصين في إدارة المتاجر الإلكترونية، وأدوات مدعومة بالذكاء الاصطناعي، ولوحة تحكم موحدة، لتمنحك رؤية شاملة وإدارة احترافية لأعمالك من مكان واحد.',
    'amWhyItem1': 'فريق متخصص في إدارة المتاجر الإلكترونية',
    'amWhyItem2': 'منصة مدعومة بالذكاء الاصطناعي',
    'amWhyItem3': 'تكامل مع أكبر منصات تجارة إلكترونية',
    'amWhyItem4': 'خبراء في إدارة الحملات الإعلانية وتنمية المبيعات',
    'amWhyItem5': 'قرارات مبنية على البيانات والتحليلات',
    'amWhyItem6': 'دعم تشغيلي متكامل من البداية إلى النمو',

    'amResultsHeading': 'نجاحات مثبتة',
    'amResultsBody': 'ساعد فريق كونكتو مئات البائعين على تنمية أعمالهم عبر أكبر منصات التجارة الإلكترونية، من خلال تحسين أداء المتاجر، وإدارة الحملات الإعلانية، وتطوير الحسابات وفق استراتيجيات مدروسة تحقق نموًا مستدامًا.',
    'amResultsSlotTitle': 'دراسات الحالة قريباً',
    'amResultsSlotDesc': 'سيتم إضافة قصص نجاح عملائنا وشهاداتهم قريباً.',

    'amCtaHeading': 'ابدأ رحلتك نحو نمو أسرع في التجارة الإلكترونية',
    'amCtaBody': 'سواء كنت تطلق متجرك الأول أو تدير أعمالك عبر عدة منصات، توفر لك Connecto الخبرة، والأدوات، والدعم الذي تحتاجه لإدارة أعمالك وتحقيق نمو مستدام.',
    'amCtaBtn': 'احجز استشارتك المجانية',
    
    'amFaqTitle': 'الأسئلة الشائعة',
    'amFaqSubtitle': 'أسئلة متكررة',
    'amFaq1Q': 'ماذا تشمل خدمة إدارة الحسابات؟',
    'amFaq1A': 'تشمل الخدمة تسجيل البائعين وإدارة الحسابات، وتحسين صفحات المنتجات، وإدارة الحملات الإعلانية، ومتابعة الطلبات والمرتجعات، ومراقبة صحة الحساب، بالإضافة إلى الدعم المستمر لتنمية أعمالك.',
    'amFaq2Q': 'هل سأحصل على مدير حساب مخصص؟',
    'amFaq2A': 'نعم، يتم تخصيص خبير في إدارة المتاجر الإلكترونية لمتابعة عملياتك اليومية، وتحسين أداء متجرك، ودعم نمو أعمالك بشكل مستمر.',
    'amFaq3Q': 'هل يمكنكم إدارة أكثر من منصة في الوقت نفسه؟',
    'amFaq3A': 'بالتأكيد. ندير أعمال البائعين عبر أمازون، نون، جوميا، كنز، نمشي، وترينديول من خلال استراتيجية موحدة تضمن كفاءة التشغيل وتحقيق أفضل النتائج.',
    'amFaq4Q': 'هل يوجد حد لعدد المنتجات التي يمكن إدارتها؟',
    'amFaq4A': 'لا، يتم تصميم الخدمة بما يتناسب مع حجم أعمالك، سواء كنت تدير عددًا محدودًا من المنتجات أو آلاف المنتجات (SKUs).',
    'amFaq5Q': 'هل تتولون إدارة الحملات الإعلانية؟',
    'amFaq5A': 'نعم، نقوم بتخطيط الحملات الإعلانية، وإطلاقها، وتحسين أدائها باستمرار، بهدف زيادة ظهور منتجاتك، وتحقيق المزيد من المبيعات، وتعظيم العائد على الإنفاق الإعلاني.',
    'scaleTitle': 'من إدارة المنتجات إلى تنمية المبيعات.. كل ما تحتاجه لتنمية متجرك في مكان واحد',
    'scaleCard1Title': 'منصة كونكتو',
    'scaleCard1Desc': 'منصة متكاملة مصممة خصيصًا لبائعي المتاجر الإلكترونية، تضم أدوات ذكية تساعدك على إنشاء صفحات المنتجات، وتحسينها، وإدارة أعمالك بكفاءة، وتسريع نمو مبيعاتك عبر Amazon وNoon وJumia وTrendyol.',
    'scaleCard2Title': 'خدمات إدارة الحسابات',
    'scaleCard2Desc': 'فريق متكامل من خبراء التجارة الإلكترونية يتولى إدارة عمليات متجرك اليومية، من تحسين المنتجات ومتابعة الأداء إلى إدارة الطلبات.',
    'scaleCard1Feat1': 'إنشاء صفحات منتجات بالذكاء الاصطناعي',
    'scaleCard1Feat2': 'توليد محتوى احترافي لزيادة المبيعات',
    'scaleCard1Feat3': 'حساب أرباح ورسوم المنصات قبل النشر',
    'scaleCard1Feat4': 'لوحة تحكم موحدة لمتابعة الأداء',
    'scaleCard2Feat1': 'تسجيل وإعداد حسابات البائعين',
    'scaleCard2Feat2': 'إنشاء القوائم وتطوير محتوى A+',
    'scaleCard2Feat3': 'إدارة الحملات الإعلانية وتنمية المبيعات',
    'scaleCard2Feat4': 'متابعة الطلبات، المرتجعات، والعمليات المالية',
  },

  en: {
    // Navbar
    'about': 'About Us',
    'services': 'Services',
    'navAccountMgmt': 'Account Management',
    'navConnectoPlatform': 'Connecto Platform',
    'navIntegrations': 'Connected Marketplace',
    'pricing': 'Pricing',
    'partners': 'Contact Us',
    'support': 'Support',
    'login': 'Login',
    'freeTrial': 'Start Free Trial',
    'tryDemo': 'TRY DEMO',
    'en': 'EN',
    'ar': 'AR',

    // Hero Section
    'heroTitle': 'Connecto integrates all e-commerce platforms into one dashboard',
    'heroSubtitle': 'Link your stores to Amazon, Noon, Jumia, Trendyol and easily control orders, inventory, and profits.',
    'watchDemo': 'Discover the Platform',
    'merchants': 'Merchants using Connecto',
    'merchantsCount': '2000+',

    // Stats Section
    'statsTitle': 'Statistics',
    'statsSubtitle': 'Your Smart Gateway to Millions of Customers',
    'statsDescription': "We don't just give you tools, we put the power of the world's largest markets in your hands from one platform",
    'growthRate': 'Business Growth',
    'salesGrowth': 'Revenue Increase',
    'trustedMerchants': 'Customer Satisfaction',
    'growthRateValue': '20x',
    'salesGrowthValue': '+500%',
    'trustedMerchantsValue': '+2,000',

    // What We Can Do For You Section
    'whatWeDoTitle': 'What We Can Do For You?',
    'whatWeDoSubtitle': "We don't just give you a dashboard; we build an integrated growth ecosystem for your business.",
    'weDo1Title': 'Unified & Total Control',
    'weDo1Desc': 'Connect your Amazon, Noon, Jumia, and Trendyol accounts. Track sales and inventory from one single place without distraction.',
    'weDo2Title': 'AI That Scales Your Business',
    'weDo2Desc': "Use 'Leo' for high-converting content and 'Alpha' for professional product image design that boosts sales.",
    'weDo3Title': 'Financial & Tax Clarity',
    'weDo3Desc': 'Calculate your real profits accurately with "Ehsably" and coordinate taxes with experts to avoid costly surprises.',
    'weDo4Title': 'Expert Training & Support',
    'weDo4Desc': 'Book specialized training sessions and consultations with professional account managers to evolve your selling strategy.',
    'startJourney': 'Start Your Journey Now',

    // Partners Section
    'integrationTitle': 'Trusted Marketplace Partnerships',
    'integrationSubtitle': 'Connected to Leading Marketplaces',
    'integrationDescription': 'Easy and fast integration through an authorised API with the largest e-commerce platforms in the region',
    'amazonPartnerBadge': 'SPN Partner',
    'noonPartnerBadge': 'FBPI API Integration',
    'jumiaPartnerBadge': 'Account Management Partner',
    'trendyolPartnerBadge': 'API Integration',

    // Features Section (One Platform)
    'onePlatformTitle': 'One Platform. Every Marketplace.',
    'onePlatformDesc': 'Manage your products, orders, and growth across the leading marketplaces in <span class="text-primary font-bold">Egypt and the GCC</span>. Connecto supports <span class="text-primary font-bold">Amazon</span>, <span class="text-primary font-bold">Noon</span>, <span class="text-primary font-bold">Jumia</span>, and <span class="text-primary font-bold">Trendyol</span>, helping you scale from a single dashboard.',

    // Bilingual homepage media placeholder
    'mediaIntroTitle': 'A Closer Look at Connecto',
    'mediaIntroBody': 'Introductory copy will be added here soon.',
    'mediaIntroVideoComingSoon': 'Video coming soon',
    'mediaIntroCarouselLabel': 'Video carousel',
    'mediaIntroSlideLabel': 'Video placeholder',
    'mediaIntroPreviousVideo': 'Previous video',
    'mediaIntroNextVideo': 'Next video',
    'mediaIntroChooseVideo': 'Choose a video',
    'mediaIntroShowVideo': 'Show video',

    // Solutions Section
    'solutionsTitle': 'Services',
    'solutionsMainTitle': 'Everything You Need to Grow on Marketplaces',
    'alpha': 'Alpha Smart Assistant',
    'alphaDesc': 'AI Product Image Designer',
    'leo': 'Leo Smart Assistant',
    'leoDesc': 'Your Smart Content Creator',
    'ehsably': 'Ehsably',
    'ehsablyDesc': 'Your Smart Pricing Assistant',
    'bekam': 'Bekam',
    'bekamDesc': 'Your Smart Price Analyzer',
    'modaq': 'Modaq',
    'modaqDesc': 'Your Personal Tax Preparation Assistant',
    'moathr': 'Moathr',
    'moathrDesc': 'Connect with Influencers to Boost Sales',
    'ema': 'Ema Smart Assistant',
    'emaDesc': 'Your Smart E-commerce Information Assistant',
    'ahjez': 'Book Expert',
    'ahjezDesc': 'Your E-commerce Account Manager',
    'salesLeads': 'Sales Leads',
    'salesLeadsDesc': 'Discover high-potential products to sell on Amazon',
    'bookTraining': 'Book Training',
    'bookTrainingDesc': 'Book expert-led training sessions',
    'vendorMarket': 'Vendor Market',
    'vendorMarketDesc': 'Discover trusted suppliers across Amazon, Noon, Jumia, and Trendyol',

    // CTA Section
    'ctaBadge': 'Launch Your Business',
    'ctaTitle': 'Start your transformation journey towards smarter e-commerce.. and more sustainable profits',
    'ctaDescription': 'Break free from the chaos of traditional management. Join the elite who run their Amazon and Noon businesses with absolute efficiency from a single central interface.',

    // Why Choose Us Section
    'whyChooseUsTitle': 'Why Marketplace Sellers Choose Connecto',
    'whyChooseUsSubtitle': 'Why Choose Us',
    'whyChooseUsDescription': 'Everything you need to create, manage, optimize, and grow your marketplace business, from AI-powered product creation to analytics and expert support, all in one platform.',
    'trustedBadge': 'Trusted By',
    'trustedTitle': 'Trusted by Marketplace Sellers',
    'trustedSubtext': 'Helping brands grow across Amazon, Noon, Jumia, Trendyol, and Kenzz',
    'reason1Title': 'AI-Powered Marketplace Tools',
    'reason1Desc': 'Create product images, generate optimized listings, calculate marketplace fees, and publish products faster using AI-powered automation.',
    'reason2Title': 'Multi-Marketplace Management',
    'reason2Desc': 'Manage Amazon, Noon, Jumia, and Trendyol from one platform with seamless integrations designed for sellers across Egypt and the GCC.',
    'reason3Title': 'Smart Analytics & Insights',
    'reason3Desc': 'Monitor sales, inventory, pricing, and product performance with real-time dashboard analytics to make data-driven decisions.',
    'reason4Title': 'Expert Support & Growth Services',
    'reason4Desc': 'Access marketplace experts, tax consultations, training, and business support to help you launch, optimize, and scale with confidence.',

    // Reviews Section
    'reviewsTitle': 'Testimonials',
    'reviewsSubtitle': 'Trusted by Sellers Across the MENA Region',
    'reviewsDescription': '',
    
    'review1Name': 'Moaz',
    'review1Text': 'Connecto helped us expand our business across Amazon KSA & UAE, Noon KSA & UAE, and Trendyol Turkey. From product listings and marketplace optimization to daily operations, their team made scaling into new markets simple and efficient.',
    
    'review2Name': 'Mohamed Taha',
    'review2Text': 'Working with Connecto helped us streamline our operations across Amazon, Noon, and Jumia. From listing optimization to daily marketplace management, the team provided the support and expertise we needed to grow with confidence.',
    
    'review3Name': 'Ali Othman',
    'review3Text': 'Using the Connecto Platform, we streamlined our product listings and improved our marketplace performance. During the White Friday season, our sales increased by 5X.',

    'review4Name': 'Mohamed Al-Amoudi',
    'review4Text': "Managing thousands of products across multiple marketplaces became effortless. Connecto saved us hours of manual work every week.",

    'review5Name': 'Rehab Mostafa',
    'review5Text': "Connecto made launching my marketplace business much easier. The team's support helped me publish my products faster and avoid common setup mistakes.",

    // Home Page FAQs
    'newHomeFaqSubtitle': 'Frequently asked questions',
    'newHomeFaqTitle': 'FAQs',
    'newHomeFaq1Q': 'What is Connecto?',
    'newHomeFaq1A': 'Connecto is a comprehensive e-commerce growth ecosystem that combines an AI-powered platform with expert Account Management services to help sellers manage, optimize, and grow their business across multiple marketplaces. From AI tools and business analytics to pricing solutions, compliance support, and dedicated marketplace experts, Connecto simplifies daily operations and enables businesses to scale efficiently across Amazon, Noon, Jumia, Trendyol, Namshi, and Kenzz.',
    'newHomeFaq2Q': 'Which marketplaces does Connecto support?',
    'newHomeFaq2A': 'Connecto supports Amazon, Noon, Jumia, Trendyol, Namshi, and Kenzz across Egypt, Saudi Arabia, the UAE, and Turkey.',
    'newHomeFaq3Q': 'What services does Connecto offer?',
    'newHomeFaq3A': 'Connecto offers AI-powered tools, marketplace Account Management, listing optimization, advertising management, dashboard analytics, pricing tools, and seller growth services.',
    'newHomeFaq4Q': 'Who is Connecto for?',
    'newHomeFaq4A': 'Connecto is designed for startups, growing brands, and enterprise sellers looking to scale across multiple marketplaces.',
    'newHomeFaq5Q': 'How do I get started?',
    'newHomeFaq5A': 'Simply create your account or [book a free consultation](/partners/). Our team will help you choose the right solution for your business.',
    'newHomeFaq6Q': 'Why choose Connecto?',
    'newHomeFaq6A': 'Unlike traditional agencies or standalone software, Connecto combines expert marketplace services with AI-powered technology into a single, comprehensive solution.',
    'newHomeFaq7Q': 'How can I contact Connecto?',
    'newHomeFaq7A': 'You can contact our team through the website, email, or by booking [a free consultation](/partners/).',

// Pricing Page General
    'pricingTitle': 'Pricing Plans',
    'pricingSubtitle': 'Plan for every budget',
    'pricingDescription': 'Experience the future of E-commerce with our secure, efficient, and user-friendly platform',
    'currency': 'EGP',
    'currencyUSD': '$',
    'perMonth': '/ month',
    'startNow': 'START NOW',

    // Pricing Page (Next.js Content)
    'pricingHeroTitle': 'Simple, Flexible Pricing for Every Seller',
    'pricingHeroBody': 'Whether you\'re just getting started or managing a growing marketplace business, Connecto offers the right plan to help you create, optimize, and scale your products with AI-powered tools and expert support.',

    'plansHeading': 'Connecto Platform',
    'plansSubheading': 'Choose the plan that fits your business today, or build a custom plan tailored to your unique needs',

    // Starter Plan
    'planStarter': 'Starter',
    'planStarterPriceUSD': '25',
    'starterFeaturesList': [
      'Studio (30 Product Listings) (using Alpha & Leo credits)',
      'Alpha AI (150 Images)',
      'Leo AI (120 Content Generations)',
      'Emma AI (160 Support Questions)',
      'Bekam (30 Competitor Pricing Checks)',
      'E7sebly (Unlimited Profit Calculations)',
      'QR & Barcode Generator (Unlimited)',
      'Dashboard Analytics (Sales & Inventory Insights) Unlimited',
    ],
    'starterCreditsNote': 'Powered by 850 AI Credits. The usage above is a suggested allocation; you can use your credits freely across eligible AI tools based on your business needs',

    // Pro Plan
    'popularLabel': 'Popular',
    'planPro': 'Pro',
    'planProPriceUSD': '50',
    'proFeaturesList': [
      'Studio (60 Product Listings) (using Alpha & Leo credits)',
      'Alpha AI (300 Images)',
      'Leo AI (240 Content Generations)',
      'Emma AI (320 Support Questions)',
      'Bekam (60 Competitor Pricing Checks)',
      'E7sebly (Unlimited Profit Calculations)',
      'Sales Leads (Unlimited)',
      'Tax Calculator (Unlimited)',
      'QR & Barcode Generator (Unlimited)',
      'Dashboard Analytics (Sales & Inventory Insights) Unlimited',
    ],
    'proCreditsNote': 'Powered by 1700 AI Credits. The usage above is a suggested allocation; you can use your credits freely across eligible AI tools based on your business needs',

    // Custom Plan
    'customTitle': 'Design Your Plan',
    'customDesc': 'Build your own package',
    'customSubdesc': 'Choose the tools and usage limits that fit your business needs.',
    'customPlanHeaderTitle': 'Design Your Plan',
    'customPlanHeaderSubtitle': 'Choose Your Usage',
    'customPlanHeaderDesc': 'Select the usage amount for each tool, and we will calculate the required credits and price automatically.',
    'customUnitGeneric': 'usage',
    'customToolStudio': 'Connecto Studio',
    'customUnitStudio': 'product pages',
    'customToolAlpha': 'Alpha',
    'customUnitAlpha': 'images',
    'customToolLeo': 'Leo',
    'customUnitLeo': 'content creations',
    'customToolEmma': 'Emma',
    'customUnitEmma': 'queries',
    'customToolBekam': 'Bekam',
    'customUnitBekam': 'price trackings',
    'customToolEhsably': 'Ehsably',
    'customToolSalesLeads': 'Sales Opportunities',
    'customToolTaxAuditor': 'Tax Report Auditor',
    'customToolQR': 'QR & Barcode Generator',
    'customToolDashboard': 'Connecto Dashboard',
    'customToolManualEdit': 'Manual Image Editing',
    'customFreeUnlimited': 'Unlimited usage — Free',
    'customFreeIncludedTitle': 'Includes Unlimited Free Access To:',
    'customTotalCreditsLabel': 'Total Required Credits',
    'customPriceLabel': 'Price for 30 days',
    'customSaleBanner': 'Limited Time Offer on Custom Plan',
    'customSaleBadge': '20% OFF',
    'customOriginalPriceLabel': 'Original price',
    'customCreditUnit': 'credits',
    'customNote': 'You can use the credits freely across all tools. The numbers selected above are only used to estimate suggested credits for your needs.',
    'customStartBtn': 'Start Now',
    'customFeaturesList': [
      'Custom Studio Credits',
      'Custom Alpha Credits',
      'Custom Leo Credits',
      'Custom E7sebly Usage',
      'Custom QR & Barcode Usage',
      'Custom Sales Leads Usage',
      'Custom Tax Calculator Usage',
      'Custom Emma Usage',
      'Custom Pricing Agent Usage',
      'Custom Dashboard Access',
      'Custom Training & Consulting',
      'Custom Users Number',
    ],
    'customStartNow': 'Start Custom Package',

    // Free Benefits
    'benefitsHeading': 'Every Connecto Plan Comes With These Free Benefits:',
    'benefitsSubheading': 'Subscribe to any Connecto plan and enjoy a range of free benefits to help you launch and manage your business efficiently.',
    'benefitsList': [
      'Multi-Marketplace API Integration',
      'Access to Verified Vendor Database',
      'E-commerce Platform Training Session',
      'One Free Consultation with a Tax Auditor',
      'Access to Marketplace Selling Opportunities',
      'One Free Consultation with an Expert Account Manager',
    ],

    // Managed Services
    'managedHeading': 'Need More Than Software?',
    'managedSubheading': 'Let Our Experts Manage Your Marketplace',
    'managedTitle': 'Managed Account Services',
    'managedBody': 'Our Account Management service is tailored to your business size, the number of marketplaces you sell on, and your monthly operations. Whether you manage one marketplace or multiple marketplaces, and whether you have 10 products or 10,000+ SKUs, our team adapts to your business needs.',
    'managedServicesList': [
      'Seller Sign-Up',
      'Listing Optimization',
      'Orders Management',
      'Returns Management',
      'Advertising Management',
      'Seller Growth Strategy',
      'Monthly Performance Reports',
      'Dedicated Account Manager',
      'Multi-Marketplace Management',
      'Unlimited Product Catalog Support',
    ],
    'getCustomQuote': 'Get a Custom Quote',

    // FAQ Section
    'faq': 'Frequently Asked Questions',
    'faqSubheading': 'Frequently asked questions',
    'pricingFaqs': [
      { q: 'How do AI Credits work?', a: 'Each subscription includes AI Credits that can be used across eligible AI tools based on your business needs.' },
      { q: 'Can I customize my plan?', a: 'Yes. You can build a custom plan based on your marketplaces, products, and required services.' },
      { q: 'What\'s included in my subscription?', a: 'Your subscription includes access to Connecto\'s AI tools, dashboard analytics, and the services included in your selected plan.' },
      { q: 'Can I upgrade or downgrade my plan?', a: 'Yes. You can change your subscription at any time as your business grows.' },
      { q: 'Is there a free trial?', a: 'Yes. Start with a free trial and explore Connecto before subscribing.' },
      { q: 'Do unused AI Credits roll over?', a: 'Unused AI Credits expire at the end of your billing cycle.' },
      { q: 'What\'s the difference between Platform and Account Management?', a: 'The Platform gives you AI tools to manage your business yourself, while Account Management provides a dedicated team to manage your marketplace operations.' },
      { q: 'Which plan is right for me?', a: 'Our Starter, Pro, and Custom plans are designed for businesses of different sizes. Our team can help you choose the best fit.' },
    ],

    // Closing CTA
    'closingHeading': 'Start Selling Smarter with Connecto Platform',
    'closingBody': 'Whether you\'re launching your first product or managing thousands of orders, Connecto gives you the AI tools, insights, and expert support to grow with confidence.',
    'signupNow': 'Sign up now',

    // Platform Page (Next.js /service/platform)
    'heroBadge': 'Connecto Platform',
    'heroTitle1': 'One Platform.',
    'heroTitle2': 'Endless Growth Opportunities.',
    'heroPara1': 'An all-in-one marketplace platform that simplifies operations, automates tasks, and helps sellers scale across multiple marketplaces, with AI-powered tools, analytics, and expert support in one place.',
    'heroPara2': '',
    'heroCta1': 'Start Free Trial',
    'heroCta2': 'Discover the Platform',

    'toolsHeading': 'Elevate Your Business with Smart Tools',
    'ctaCardTitle': 'More tools coming soon',
    'ctaCardDesc': 'New additions are on the way.',

    'toolStudioName': 'Connecto Studio',
    'toolStudioDesc': 'Create and publish complete AI-powered product listings',
    'toolStudioDoes1': 'Creates complete marketplace-ready product listings',
    'toolStudioDoes2': 'Generates AI product images and content',
    'toolStudioDoes3': 'Auto-fills marketplace listing schemas',
    'toolStudioDoes4': 'Calculates marketplace fees',
    'toolStudioDoes5': 'Publishes directly to Amazon, Noon, Jumia & Trendyol',
    'toolStudioGet1': 'Launch products up to 5× faster',
    'toolStudioGet2': 'Save hours of manual work',
    'toolStudioGet3': 'Publish optimized, error-free listings',
    'toolStudioGet4': 'End-to-end workflow from creation to publishing',

    'toolAlphaName': 'Alpha',
    'toolAlphaDesc': 'Generate professional product images in seconds',
    'toolAlphaDoes1': 'Generates AI product images',
    'toolAlphaDoes2': 'Creates lifestyle images and infographics',
    'toolAlphaDoes3': 'Removes backgrounds automatically',
    'toolAlphaDoes4': 'Enhances product images',
    'toolAlphaGet1': 'Professional product visuals',
    'toolAlphaGet2': 'Marketplace-compliant images',
    'toolAlphaGet3': 'Better product presentation',
    'toolAlphaGet4': 'Higher conversion potential',

    'toolLeoName': 'Leo',
    'toolLeoDesc': 'Create optimized content for better product visibility',
    'toolLeoDoes1': 'Generates titles, descriptions, bullet points & keywords',
    'toolLeoDoes2': 'Creates Bilingual content',
    'toolLeoDoes3': 'Optimizes content for marketplace SEO',
    'toolLeoGet1': 'Better search visibility',
    'toolLeoGet2': 'Higher-quality listings',
    'toolLeoGet3': 'Faster content creation',
    'toolLeoGet4': 'Improved customer engagement',

    'toolEmmaName': 'Emma',
    'toolEmmaDesc': 'Your AI assistant for instant marketplace support',
    'toolEmmaDoes1': 'Answers marketplace questions instantly',
    'toolEmmaDoes2': 'Provides official marketplace guidance',
    'toolEmmaDoes3': 'Assists with seller operations',
    'toolEmmaGet1': 'Save time searching for information',
    'toolEmmaGet2': 'Avoid policy violations',
    'toolEmmaGet3': 'Make informed business decisions',
    'toolEmmaGet4': 'Get instant expert assistance',

    'toolDashboardName': 'Dashboard Analytics',
    'toolDashboardDesc': 'Monitor sales, inventory, and business performance',
    'toolDashboardDoes1': 'Tracks sales, inventory & orders',
    'toolDashboardDoes2': 'Monitors marketplace performance',
    'toolDashboardDoes3': 'Provides real-time business insights',
    'toolDashboardGet1': 'One dashboard for all marketplaces',
    'toolDashboardGet2': 'Better business decisions',
    'toolDashboardGet3': 'Complete visibility into your operations',

    'toolE7seblyName': 'E7sebly',
    'toolE7seblyDesc': 'Calculate marketplace fees and estimated profits instantly',
    'toolE7seblyDoes1': 'Calculates marketplace fees',
    'toolE7seblyDoes2': 'Estimates shipping costs',
    'toolE7seblyDoes3': 'Calculates expected profits',
    'toolE7seblyGet1': 'Know your profit before selling',
    'toolE7seblyGet2': 'Price products confidently',
    'toolE7seblyGet3': 'Avoid unexpected costs',

    'toolBekamName': 'Bekam',
    'toolBekamDesc': 'Track competitor prices and pricing trends',
    'toolBekamDoes1': 'Tracks competitor prices',
    'toolBekamDoes2': 'Monitors price history',
    'toolBekamDoes3': 'Analyzes pricing trends',
    'toolBekamGet1': 'Stay competitive',
    'toolBekamGet2': 'Optimize pricing strategy',
    'toolBekamGet3': 'Maximize profit margins',

    'toolQRName': 'QR & Barcode Generator',
    'toolQRDesc': 'Generate QR codes and barcodes instantly',
    'toolQRDoes1': 'Generates QR codes',
    'toolQRDoes2': 'Creates marketplace-ready barcodes',
    'toolQRGet1': 'Faster product setup',
    'toolQRGet2': 'Simplified inventory management',
    'toolQRGet3': 'Marketplace-compliant product codes',

    'toolSalesName': 'Sales Leads',
    'toolSalesDesc': 'Discover new products and selling opportunities',
    'toolSalesDoes1': 'Discovers high-potential products',
    'toolSalesDoes2': 'Identifies marketplace opportunities',
    'toolSalesDoes3': 'Analyzes market demand',
    'toolSalesGet1': 'Find winning products faster',
    'toolSalesGet2': 'Reduce product research time',
    'toolSalesGet3': 'Make data-driven selling decisions',

    'toolSellName': 'Sell With Us',
    'toolSellDesc': 'Grow your business with Connecto\'s experts',
    'toolSellDoes1': 'Connects you with marketplace specialists',
    'toolSellDoes2': 'Provides account management services',
    'toolSellDoes3': 'Supports marketplace expansion',
    'toolSellGet1': 'Faster business growth',
    'toolSellGet2': 'Expert operational support',
    'toolSellGet3': 'Scale with confidence',

    'toolTaxName': 'Tax Calculator',
    'toolTaxDesc': 'Estimate taxes quickly and accurately',
    'toolTaxDoes1': 'Estimates taxes',
    'toolTaxDoes2': 'Calculates tax obligations',
    'toolTaxDoes3': 'Supports financial planning',
    'toolTaxGet1': 'Simplified tax preparation',
    'toolTaxGet2': 'More accurate calculations',
    'toolTaxGet3': 'Better financial planning',

    'toolConsultantName': 'Book Consultant',
    'toolConsultantDesc': 'Book a session with marketplace specialists',
    'toolConsultantDoes1': 'Schedule one-on-one expert consultations',
    'toolConsultantDoes2': 'Review marketplace performance',
    'toolConsultantDoes3': 'Build a personalized growth plan',
    'toolConsultantGet1': 'Clear action plan',
    'toolConsultantGet2': 'Faster business growth',
    'toolConsultantGet3': 'Expert recommendations',

    'toolVendorName': 'Vendor Market',
    'toolVendorDesc': 'Connect with trusted suppliers and vendors',
    'toolVendorDoes1': 'Supports supplier sourcing',
    'toolVendorDoes2': 'Connects you with verified suppliers',
    'toolVendorDoes3': 'Compares vendors by quality and pricing',
    'toolVendorGet1': 'Trusted supplier network',
    'toolVendorGet2': 'Better sourcing decisions',
    'toolVendorGet3': 'Stronger business partnerships',

    'toolTrainingName': 'Book Training',
    'toolTrainingDesc': 'Learn from experts and grow your marketplace skills',
    'toolTrainingDoes1': 'Book marketplace training sessions',
    'toolTrainingDoes2': 'Learn platform best practices',
    'toolTrainingDoes3': 'Receive expert guidance',
    'toolTrainingGet1': 'Improve your marketplace skills',
    'toolTrainingGet2': 'Stay up to date with industry trends',
    'toolTrainingGet3': 'Grow your business with confidence',

    'howItWorksBadge': 'How It Works',
    'howItWorksSubtitle': '',
    'howItWorksStep1Title': 'Create your account & sign in',
    'howItWorksStep1Desc': 'Create your account using your email and log in to the Connecto platform.',
    'howItWorksStep2Title': 'Connect your e-commerce platforms',
    'howItWorksStep2Desc': 'Link Amazon, Noon, Jumia, Trendyol and more in a few clicks. One-time setup, always in sync.',
    'howItWorksStep3Title': 'See all your data in one dashboard',
    'howItWorksStep3Desc': 'Sales, orders, inventory, and performance — every platform aggregated into a single, clean view.',
    'howItWorksStep4Title': 'Leverage AI tools to grow faster',
    'howItWorksStep4Desc': 'Smart insights, trend predictions, and actionable recommendations powered by AI — built to push your business further every day.',
    'howItWorksStep5Title': 'Enjoy ultimate control over every platform',
    'howItWorksStep5Desc': 'Manage, compare, and act across all your stores from one place. This is what running a modern e-commerce business feels like.',

    'section3Subtitle': 'Smart tools designed to simplify your operations and accelerate your marketplace growth',
    'whatItDoes': 'What It Does',
    'whatYouGet': 'What You Get',
    'startFreeTrial': 'Start Free Trial',

    'marketplaceBadge': 'Marketplace Coverage',
    'marketplaceHeading': 'Marketplace Coverage',
    'marketplaceSubheading': 'Sell Across the Region with One Platform',
    'marketplaceBody': 'Connecto integrates with the leading marketplaces across Egypt, Saudi Arabia, the UAE, and Turkey, giving you one place to create, manage, and grow your business.',
    'integratedWith': 'Supported Marketplaces',

    'ctaHeading': 'Everything You Need to Sell Smarter',
    'ctaHeadingBase': 'Everything You Need to Sell ',
    'ctaHeadingHighlight': 'Smarter',
    'ctaBody': 'Whether you\'re launching your first product or managing thousands of listings, Connecto gives you the AI tools, analytics, and expert support to grow faster, all from one platform.',
    'ctaBtn1': 'Start Your Free Trial',
    'ctaBtn2': 'Book a Consultation',

    'faqTitle': 'FAQs',
    'faqSubtitle': 'Frequently asked questions',
    'faq1Q': 'What is the Connecto Platform?',
    'faq1A': 'Connecto Platform is an AI-powered workspace that helps sellers create listings, manage marketplace operations, analyze performance, and grow their business from one unified dashboard.',
    'faq2Q': 'Which AI tools are included?',
    'faq2A': 'The platform includes Connecto Studio, Alpha, Leo, Emma, Bekam, E7sebly, Dashboard Analytics, QR & Barcode Generator, and more.',
    'faq3Q': 'Can I manage multiple marketplaces?',
    'faq3A': 'Yes. Connect your marketplace accounts and manage sales, inventory, orders, and analytics from one centralized dashboard.',
    'faq4Q': 'Is Connecto suitable for beginners?',
    'faq4A': 'Yes. Whether you\'re launching your first product or managing an established business, Connecto provides tools and guidance to support every stage.',
    'faq5Q': 'Does Connecto support Arabic and English?',
    'faq5A': 'Yes. Our AI tools can generate content and support sellers in both Arabic and English.',
    'faq6Q': 'Can my team use the platform?',
    'faq6A': 'Yes. Connecto is built for individuals, growing teams, and enterprise businesses.',

    // About Page (Next.js /about)
    'aboutBadge': 'About Us',
    'aboutTitle': 'Empowering Sellers. Connecting Markets. Driving Growth.',
    'aboutBody': 'Connecto was built to simplify e-commerce operations by combining AI-powered technology with expert marketplace services. We help businesses manage, optimize, and grow across the region\'s leading marketplaces through one intelligent ecosystem.',

    'storyTitle': 'Our Story',
    'storyBody1': 'As marketplace businesses grow, managing multiple platforms, operations, and daily tasks becomes increasingly complex. We created Connecto to change that.',
    'storyBody2': 'By combining AI-powered technology with expert Account Management, Connecto brings everything sellers need into one intelligent ecosystem, helping businesses simplify operations, make smarter decisions, and grow across the region\'s leading marketplaces.',

    'missionTitle': 'Our Mission',
    'missionBody': 'To empower e-commerce sellers with intelligent technology, expert guidance, and data-driven solutions that simplify operations and accelerate growth.',
    'visionTitle': 'Our Vision',
    'visionBody': 'To become the trusted growth partner and intelligent infrastructure behind every successful marketplace business in the MENA region.',

    'valuesBadge': 'Our Core Values',
    'valuesTitle': 'Our Core Values',
    'value1Title': 'Customer First',
    'value2Title': 'Continuous Growth',
    'value3Title': 'Transparency & Trust',
    'value4Title': 'Innovation with Purpose',

    'whyTitle': 'Why Businesses Choose Connecto',
    'whySubtitle': '',
    'whyCard1Title': 'AI-Powered Platform',
    'whyCard1Body': 'Automate product creation, pricing, analytics, and marketplace operations.',
    'whyCard2Title': 'Expert Account Management',
    'whyCard2Body': 'Dedicated marketplace specialists managing your daily operations and growth.',
    'whyCard3Title': 'Multi-Marketplace Expertise',
    'whyCard3Body': 'Sell across Amazon, Noon, Jumia, Trendyol, Namshi, and Kenzz.',
    'whyCard4Title': 'Data-Driven Growth',
    'whyCard4Body': 'Make smarter decisions with real-time analytics and business insights.',

    'profileTitle': 'Want to learn more about Connecto?',
    'profileBody': 'Download our Company Profile to explore our services, platform, success stories, and marketplace expertise.',
    'profileBtn': 'Download Company Profile',

    'impactTitle': 'Our Impact',
    'stat1Value': '2,000+',
    'stat1Label': 'Sellers Supported',
    'stat2Value': '500%+',
    'stat2Label': 'Revenue Growth',
    'stat3Value': '20×',
    'stat3Label': 'Faster Business Growth',
    'stat4Value': '6+',
    'stat4Label': 'Marketplace Integrations',
    'impactBtn': 'Start Your Growth Journey with Connecto Now',

    'aboutClosingTitle': 'Let\'s Grow Your Marketplace Business',
    'aboutClosingBody': 'Book a free consultation with our marketplace experts and discover how Connecto can help you grow across Amazon, Noon, Jumia, Trendyol, Namshi, and Kenzz.',
    'aboutClosingCheck1': 'Free Marketplace Consultation',
    'aboutClosingCheck2': 'Personalized Growth Strategy',
    'aboutClosingCheck3': 'One Platform. One Workflow.',
    'aboutConsultBtn': 'Book Your Free Consultation',

    // Account Management Page
    'amHeroBadge': 'A Verified Amazon SPN Partner',
    'amHeroTitle': 'Marketplace Account Management',
    'amHeroSubtitle': 'We Manage the Operations. You Focus on Growth.',
    'amHeroBody': 'From seller onboarding and listing optimization to advertising, financial operations, and business growth, Connecto becomes your dedicated marketplace management team across Amazon, Noon, Jumia, Trendyol, Namshi, and Kenzz.',
    'amHeroCta': 'Book a Free Consultation',
    'amHeroBadgeLink': 'https://sellercentral.amazon.com/gspn/provider-details/Training/ebfe81a2-8a6f-48c9-a921-a560638b57a9?ref_=sc_gspn_trlst_trdt-ebfe81a2&localeSelection=en_US&sellFrom=US&sellIn=US',

    'amRoadmapTitle': 'Your Journey Roadmap',
    'amRoadmapStep1': 'Seller Sign-Up',
    'amRoadmapStep2': 'Listing & Content Enhancements',
    'amRoadmapStep3': 'Managing Orders & Financials',
    'amRoadmapStep4': 'Managing Returns',
    'amRoadmapStep5': 'Ads Campaigns',
    'amRoadmapStep6': 'Seller Growth',

    'amCoverageHeading': 'Marketplace Coverage',
    'amCoverageSubheading': 'Expand Your Business Across Leading Marketplaces',
    'amCoverageBody': 'Grow your business with Connecto\'s expert Account Management services across the region\'s leading marketplaces. From launching your store to managing daily operations and driving long-term growth, our team helps you succeed on every platform.',
    'amCoverageCta': 'Explore all Supported Marketplaces',
    'amCoverageRegion': 'Supporting sellers across Egypt, Saudi Arabia, and the UAE.',

    'amWhatWeDo': 'What We Do',
    'amWhatYouGet': 'What You Get',

    'amService1Title': 'Seller Sign-Up',
    'amService1Do': 'We establish and manage your seller accounts across Amazon, Noon, Jumia, and Trendyol, ensuring a smooth onboarding process and a strong foundation for long-term marketplace success.',
    'amService1Get': 'Seller account setup, Marketplace onboarding, Store configuration, Optimized account setup, Ongoing account management',
    'amService2Title': 'Listing & Content Enhancements',
    'amService2Do': 'We create and enhance product listings with optimized content and premium A+ experiences that showcase your products, strengthen your brand, and increase conversions.',
    'amService2Get': 'Product listing creation, Premium A+ content, Content optimization, Brand-focused product pages, Conversion-driven listings',
    'amService3Title': 'Managing Orders & Financials',
    'amService3Do': 'We oversee your daily marketplace operations, helping you manage orders, payments, and financial activities efficiently to keep your business running smoothly.',
    'amService3Get': 'Order management, Payment monitoring, Financial operations, Marketplace performance tracking, Operational efficiency',
    'amService4Title': 'Managing Returns',
    'amService4Do': 'We handle return requests and customer-related marketplace processes, helping maintain a positive shopping experience while protecting your seller performance.',
    'amService4Get': 'Return management, Customer issue handling, Refund coordination, Marketplace case follow-up, Seller performance protection',
    'amService5Title': 'Ads Campaigns',
    'amService5Do': 'We plan, launch, and continuously optimize advertising campaigns across Amazon, Noon, Jumia, and Trendyol to increase visibility, attract targeted customers, and maximize your return on ad spend.',
    'amService5Get': 'Campaign strategy, Campaign management, Audience targeting, Performance optimization, ROAS improvement',
    'amService6Title': 'Seller Growth',
    'amService6Do': 'We continuously optimize your marketplace performance to increase product visibility, improve rankings, and help your business achieve sustainable sales growth.',
    'amService6Get': 'Performance optimization, Product ranking improvement, Sales growth strategy, Marketplace expansion, Long-term business growth',

    'amWhyHeading': 'Why Connecto?',
    'amWhyBody': 'Unlike traditional agencies, Connecto combines experienced marketplace specialists with AI-powered tools and a centralized dashboard, giving you complete visibility and professional account management from one place.',
    'amWhyItem1': 'Dedicated Marketplace Experts',
    'amWhyItem2': 'AI-Powered Platform',
    'amWhyItem3': 'Multi-Marketplace Management',
    'amWhyItem4': 'Advertising & Growth Specialists',
    'amWhyItem5': 'Data-Driven Decisions',
    'amWhyItem6': 'End-to-End Operational Support',

    'amResultsHeading': 'Results That Speak for Themselves',
    'amResultsBody': 'Our marketplace specialists have helped sellers achieve significant business growth through continuous optimization, advertising management, and strategic account development.',
    'amResultsSlotTitle': 'Case Studies Coming Soon',
    'amResultsSlotDesc': 'Client success stories and testimonials will be added shortly.',

    'amCtaHeading': 'Ready to Scale Your Marketplace Business?',
    'amCtaBody': 'Whether you\'re launching your first store or managing multiple marketplaces, Connecto gives you the expertise, tools, and support to grow faster.',
    'amCtaBtn': 'Book Your Free Consultation',
    
    'amFaqTitle': 'FAQs',
    'amFaqSubtitle': 'Frequently asked questions',
    'amFaq1Q': 'What does Account Management include?',
    'amFaq1A': 'Our service covers seller onboarding, listing optimization, advertising management, order and return handling, account health monitoring, and continuous growth support.',
    'amFaq2Q': 'Do I get a dedicated Account Manager?',
    'amFaq2A': 'Yes. Every Account Management client works with a dedicated marketplace specialist who oversees daily operations and business performance.',
    'amFaq3Q': 'Can you manage multiple marketplaces?',
    'amFaq3A': 'Yes. We manage businesses across Amazon, Noon, Jumia, Trendyol, Namshi, and Kenzz through one coordinated strategy.',
    'amFaq4Q': 'Is there a limit to the number of products?',
    'amFaq4A': 'No. Our service is customized based on your catalog size, whether you manage a few products or thousands of SKUs.',
    'amFaq5Q': 'Do you manage advertising campaigns?',
    'amFaq5A': 'Yes. We create, optimize, and monitor advertising campaigns to improve visibility, increase sales, and maximize return on ad spend.',
    'howItWorksTitle': 'How It Works',
    'howItWorksMainTitle': 'Go from zero to full control in five steps',
    'step1Title': 'Create your account & sign in',
    'step1Desc': 'Create your account using your email and log in to the Connecto platform.',
    'step1Badge': 'Takes under 2 minutes',
    'step2Title': 'Connect your e-commerce platforms',
    'step2Desc': 'Link Amazon, Noon, Jumia, Trendyol, Shopify and more in a few clicks. One-time setup, always in sync.',
    'step2Badge': 'Amazon · Noon · Jumia · Trendyol · Shopify',
    'step3Title': 'See all your data in one dashboard',
    'step3Desc': 'Sales, orders, inventory, and performance — every platform aggregated into a single, clean view. No more switching between different platforms.',
    'step3Badge': 'Live data · Unified view',
    'step4Title': 'Leverage AI tools to grow faster',
    'step4Desc': 'Smart insights, trend predictions, and actionable recommendations powered by AI — built to push your business further every day.',
    'step4Badge': 'AI-powered insights',
    'step5Title': 'Enjoy ultimate control over every platform',
    'step5Desc': 'Manage, compare, and act across all your stores from one place. This is what running a modern e-commerce business feels like.',
    'step5Badge': 'Total command center',

    // Services Section (from website)
    'ourServicesTitle': 'Our Services',
    'ourServicesSubtitle': 'Empowering E-commerce Innovation Through Cutting-Edge Services',
    'service1Title': 'Full Account Management',
    'service1Desc': 'Providing daily, weekly reports. Improving the Seller Rating. Improving content & listing SKUs. Working to increase sales. Focus on the best-selling products. Managing the seller account.',
    'service2Title': 'Ads & Campaigns on Platforms',
    'service2Desc': 'Developing advertising campaigns. Plan for monitoring and operation. Evaluating the performance. Boost account sales. Providing daily, weekly reports. Providing WhatsApp updates.',
    'service3Title': 'Catalog & A+ Content Management',
    'service3Desc': 'Listing new Products/SKUs. Improving the content to A+. Improving images display. Enhancing product description. Focus on the best-selling products.',

    // About Page 
    'aboutSubtitle': 'Building the future of e-commerce',
    
    'aboutStory': 'About Us',
    'aboutStoryText': 'Connecto also works to help manage accounts on e-commerce platforms by providing all possible expertise to help sellers in developing their business on selling platforms, as well as increasing potential sales.',
    'aboutStoryText2': 'We empower sellers by simplifying complex inventory and catalog management, providing access to growth capital, and offering a wider range of product sourcing options.',
    
    'aboutVision': 'Vision',
    'aboutVisionText': 'To be the trusted digital infrastructure behind every successful e-commerce seller in emerging and global markets.',
    
    'aboutMission': 'Mission',
    'aboutMissionText': 'Our mission is to simplify and optimize e-commerce operations by providing integrated, AI-powered solutions that transform data into clear decisions, higher performance, and sustainable profitability.',
    
    'aboutOurMessage': 'Our Message',
    'aboutOurMessageText': 'Empowering e-commerce sellers to make accurate, data-driven decisions that drive peak performance and sustainable profitability.',

    'aboutValues': 'Our Values',
    
    'aboutValue1': 'Customer First',
    'aboutValue1Desc': 'We prioritize our customers\' needs in every decision and every feature we build',
    
    'aboutValue2': 'Data-Driven Mindset',
    'aboutValue2Desc': 'We rely on precise data analysis to make the best decisions and achieve tangible results',
    
    'aboutValue3': 'Speed with Excellence',
    'aboutValue3Desc': 'We deliver fast solutions without compromising on quality and excellence standards',
    
    'aboutValue4': 'Integrity & Transparency',
    'aboutValue4Desc': 'We believe in complete transparency with our clients and build relationships based on trust',
    
    'aboutValue5': 'Ownership & Impact',
    'aboutValue5Desc': 'We focus on achieving tangible and impactful results that help our clients grow and thrive',
    
    'aboutValue6': 'Growth Mindset',
    'aboutValue6Desc': 'We constantly strive to evolve, learn, and keep up with the latest trends in e-commerce',
    
    'aboutStats1': 'Customer Satisfaction',
    'aboutStats2': 'Revenue Increase',
    'aboutStats3': 'Business Growth',

    // Support Page
    'supportTitle': 'Support',
    'supportSubtitle': 'We are here to help you every step of the way',
    'partnershipsSection': 'Our Partners',
    'partnershipsDesc': 'We work with the largest e-commerce platforms to provide an integrated experience',
    'faqSection': 'FAQ',
    'contactSection': 'Contact Us',
    'contactDesc': 'We are totally available from Sunday to Thursday from 9 AM to 5 PM and you can contact us any time',
    'contactName': 'Name',
    'contactEmail': 'Email',
    'contactCountry': 'Company Country',
    'contactPhoneCountry': 'Phone Country',
    'contactSelectCountry': 'Select country',
    'contactInvalidPhone': 'Please enter a valid phone number',
    'contactMobile': 'Mobile Number',
    'contactSubject': 'Subject',
    'contactMessage': 'Message',
    'contactSend': 'Send Message',
    'supportSubmitting': 'Sending...',
    'supportSuccessTitle': 'Message Sent Successfully!',
    'supportSuccessMessage': 'Thank you for contacting us. Our support team will review your message and get back to you shortly.',
    'supportSubmitAnother': 'Send Another Message',
    'supportErrorMessage': 'An error occurred while sending. Please try again.',
    'consultFormName': 'Full name',
    'consultFormEmail': 'Email address',
    'consultFormPhone': 'Phone number',
    'consultFormMessage': 'Message',
    'consultButton': 'Submit request',
    'consultSuccess': 'Your request has been received. Our team will contact you.',

    'phoneLabel': 'Phone',
    'emailLabel': 'Email',
    'addressLabel': 'Address',

    // Solutions Page
    'solutionsPageTitle': 'Our Smart Solutions',
    'solutionsPageSubtitle': 'A complete set of smart tools designed for your e-commerce growth',
    'learnMore': 'Learn More',

    
     // About Platform Page 
    'aboutPlatform': 'About Us',
    'aboutPlatformTitle': 'Take Your E-Commerce Business to the Next Level',
    'aboutPlatformSubtitle': 'Everything You Need as a Seller… In One Place.',
    
    'painPoint1': 'Are you wasting time switching between multiple platforms?',
    'painPoint2': 'Do your decisions feel like guesswork?',
    'painPoint3': 'Are you selling… but unsure where your profits are going?',
    
    'solutionHere': 'The best solution is here:',
    'solutionDesc': 'Our intelligent ecosystem combines Management + Analytics + Marketing + Pricing + Compliance into one powerful system designed specifically for sellers on:',
    
    // Connecto Feature
    'connectoFeature': 'Connecto 🔗',
    'connectoDesc': 'Control All Your Accounts from One Dashboard',
    'connectoBenefit1': 'Stop logging in and out of multiple platforms.',
    'connectoBenefit2': 'Stop manually comparing reports.',
    'connectoBenefit3': 'Connecto gives you complete visibility across all your accounts in one smart dashboard.',
    'connectoResult': 'What You Get?',
    'connectoResultDesc': 'Instant performance comparison across marketplaces • Strength and weakness analysis • Accurate daily sales tracking • Faster decisions based on real data',  // Merged here
    'connectoFinalResult': 'The Result: Increase your profits because you finally see the full picture.',
    
    'pf1Title': 'Alpha 🎨',
    'pf1Subtitle': 'Professional Product Images That Increase Sales in Minutes',
    'pf1WhyImportant': 'Why It Matters?',
    'pf1Desc': 'Customers decide in seconds. Your image either sells… or gets ignored. Alpha transforms your ordinary product photos into high-converting, professional visuals using AI:',
    'pf1c1': 'Marketplace-compliant images',
    'pf1c2': 'Clean or creative backgrounds',
    'pf1c3': 'No expensive photoshoots',
    'pf1c4': 'Faster product launches',
    'pf1Note': 'The Result: Better images = Higher CTR = More sales',
    
    'pf2Title': 'Leo ✍️',
    'pf2Subtitle': 'Content That Makes Customers Say "I Want This"',
    'pf2Desc': 'Weak descriptions kill sales. Poor titles make you invisible. Leo creates high-converting product content:',
    'pf2c1': 'Search-optimized titles',
    'pf2c2': 'Persuasive descriptions',
    'pf2c3': 'Powerful selling points highlighting your competitive edge',
    'pf2Note': 'The Result: Better visibility + Higher trust + More conversions',
    
    'pf3Title': 'Price Calculator 💰',
    'pf3Subtitle': 'Don’t Launch a Product Before Knowing Your Real Profit',
    'pf3Desc': 'How many times have you sold a product and realized your margin was lower than expected? Ehsabli calculates everything:',
    'pf3c1': 'Purchase cost',
    'pf3c2': 'Shipping & customs',
    'pf3c3': 'Marketplace commissions',
    'pf3c4': 'Taxes',
    'pf3Note': 'The Result: Know your net profit before you launch. No surprises. No hidden losses.',
    
    'pf4Title': 'Selling History 📊',
    'pf4Subtitle': 'Know the Market Price Before Your Competitor Does',
    'pf4Desc': 'Random pricing leads to guaranteed losses. Bekam analyzes competitor pricing and shows you:',
    'pf4c1': 'Highest, lowest, and average prices',
    'pf4c2': 'Price trends over the last 3 months',
    'pf4c3': 'Market direction (rising or falling?)',
    'pf4Note': 'The Result: Smart pricing = Stronger competition + Sustainable profit',
    
    'pf5Title': 'Emma 🤖',
    'pf5Subtitle': 'Instant Answers to All Your Marketplace Questions',
    'pf5Desc': 'Spending hours searching for policies or fees? Emma gives you instant answers from verified sources:',
    'pf5c1': 'Policies',
    'pf5c2': 'Fees',
    'pf5c3': 'Listing requirements',
    'pf5c4': 'Market insights',
    'pf5Note': 'The Result: Faster decisions = Faster execution = Faster growth',
    
    'pf6Title': 'Tax Auditor 🧾',
    'pf6Subtitle': 'Your Taxes… Without the Headache',
    'pf6Desc': 'Book a session with a specialized e-commerce accountant and ensure full compliance:',
    'pf6c1': 'Avoid penalties',
    'pf6c2': 'Stay fully compliant',
    'pf6c3': 'Gain peace of mind',
    'pf6Note': 'The Result: Avoid penalties • Stay fully compliant • Gain peace of mind',
    
    'pf7Title': 'Book an Expert 📈',
    'pf7Subtitle': 'Professional Account Evaluation = Sales Growth',
    'pf7Desc': 'A marketplace specialist analyzes your account and provides a practical, actionable growth plan. Not theory — real steps to improve ranking and increase sales:',
    'pf7c1': 'Extensive experience across Amazon, Noon, Trendyol, and Jumia',
    'pf7c2': 'Practical, actionable growth plan',
    'pf7c3': 'Achieving 300x+ sales growth with merchants',
    'pf7Note': 'The Result: Extensive experience across Amazon, Noon, Trendyol, and Jumia. Achieving 300x+ sales growth with merchants.',
    
    'pf8Title': 'Influencer 📣',
    'pf8Subtitle': 'Expand Your Reach Through Influencer Marketing',
    'pf8Desc': 'Reaching your target audience has never been easier:',
    'pf8c1': 'Find the right influencers',
    'pf8c2': 'Simplify collaboration',
    'pf8c3': 'Track campaign performance',
    'pf8Note': 'The Result: More awareness = More demand = More sales',
    
    'pf9Title': 'Why Are We Different?',
    'pf9Subtitle': 'We don’t offer a single tool',
    'pf9Desc': 'We provide a complete growth ecosystem for sellers:',
    'pf9c1': 'Instead of disconnected tools',
    'pf9c2': 'Instead of guess-based decisions',
    'pf9c3': 'Instead of wasted time',
    'pf9Note': 'Full visibility + Data-driven decisions + Faster execution + Sustainable growth',
    
    'ctaReady': 'Ready to Double Your Results?',
    'ctaBenefit1': 'Save your time',
    'ctaBenefit2': 'Increase your profits',
    'ctaBenefit3': 'Let your data work for you',
    'ctaDesc': 'Start today. Let your data work for you.',
    'ctaButton': 'Try Now',

    // Partners Page
    'partnersPageTitle': 'Partnerships',
    'partnersPageSubtitle': 'We\'d Love to Connect With You',
    'partnersPageDescription': 'We believe strong partnerships are the foundation of success. Join the Connecto partner network and be part of an ecosystem reshaping the future of e-commerce in the region.',
    'partnerFormTitle': 'Partnership Application',
    'partnerName': 'Full Name',
    'partnerEmail': 'Email',
    'partnerCountry': 'Country',
    'partnerSelectCountry': 'Select Country',
    'partnerMobile': 'Mobile Number',
    'partnerMessage': 'Message',
    'partnerMessagePlaceholder': 'Tell us about your company and how we can collaborate...',
    'partnerSubmit': 'Submit Application',
    'partnerSubmitting': 'Submitting...',
    'partnerSuccessTitle': 'Application Submitted Successfully!',
    'partnerSuccessMessage': 'Thank you for your interest in partnering with us. Our team will review your application and get back to you shortly.',
    'partnerSubmitAnother': 'Submit Another Application',
    'partnerErrorMessage': 'An error occurred while submitting. Please try again.',
    'partnerWhyTitle': 'Why Partner With Connecto?',
    'partnerWhy1Title': 'Wide Network',
    'partnerWhy1Desc': 'Direct access to over 1,000 active merchants across the region',
    'partnerWhy2Title': 'Rapid Growth',
    'partnerWhy2Desc': 'Shared revenue opportunities with growth exceeding 500% annually',
    'partnerWhy3Title': 'Dedicated Support',
    'partnerWhy3Desc': 'A specialized team to support partners and maximize partnership value',
    'partnerHappy': 'We\'d love to hear from you',
    'partnerFormDesc': 'Fill out the form below and our team will get back to you within 24 hours',

    // Admin Partners Page
    'adminPartnersTitle': 'Partnership Applications',
    'adminPartnersSubtitle': 'Manage and review submitted partnership applications',
    'adminTotalApplications': 'Total Applications',
    'adminNoApplications': 'No partnership applications yet',
    'adminColumnName': 'Name',
    'adminColumnEmail': 'Email',
    'adminColumnCountry': 'Country',
    'adminColumnPhone': 'Phone',
    'adminColumnMessage': 'Message',
    'adminColumnDate': 'Date Submitted',
    'adminColumnStatus': 'Status',
    'adminStatusNew': 'New',

    // Footer
    'rights': 'All Rights Reserved',
    'companyName': 'Connecto',
    'year': '2025',
    'quickLinks': 'Quick Links',
    'contactUs': 'Contact Us',
    'email': 'sellers@connecto-me.com',
    'address': 'Building No. 1 - Chillout Lotus Maxim - Third Floor, Fifth Settlement - New Cairo - Egypt',
    'company': 'Company',
    'terms': 'Terms & Conditions',
    'privacy': 'Privacy Policy',
    'partnerships': 'Partnerships',
    'footerDescription': 'We simplify inventory and catalog management, provide growth capital, and offer localized solutions, empowering sellers to scale effortlessly. Join us to streamline operations and boost sales with AI-driven tools and priority support.',

     // Privacy Policy Page
    'privacyPolicy': 'Privacy Policy',
    
    'introTitle': 'Introduction',
    'introText': 'Welcome to Connecto. We are committed to protecting your privacy and handling your data in an open and transparent manner. This Privacy Policy explains how we collect, use, and protect information when you use our Amazon Seller Central integration platform.',
    
    'dataCollectTitle': 'Data We Collect from Amazon SP-API',
    'dataCollectText': 'When you connect your Amazon Seller Central account to our platform, we collect and store only the following non-personally identifiable information:',
    'dataCollectItem1': 'Seller account credentials (encrypted refresh tokens and access tokens)',
    'dataCollectItem2': 'Selling Partner ID (SP-ID)',
    'dataCollectItem3': 'Marketplace IDs',
    'dataCollectItem4': 'Order IDs and order financial data (non-PII)',
    'dataCollectItem5': 'Product and inventory data',
    'dataCollectItem6': 'Sales metrics and performance data',
    
    'dataNotCollectTitle': 'Data We Do NOT Collect',
    'dataNotCollectText': 'In compliance with Amazon\'s SP-API Data Protection Policy, we explicitly DO NOT store or process any Personally Identifiable Information (PII), including:',
    'dataNotCollectItem1': 'Buyer names',
    'dataNotCollectItem2': 'Buyer email addresses',
    'dataNotCollectItem3': 'Buyer phone numbers',
    'dataNotCollectItem4': 'Shipping addresses',
    'dataNotCollectItem5': 'Billing addresses',
    'dataNotCollectItem6': 'Any other customer personal information',
    'dataNotCollectNote': 'All PII returned by Amazon SP-API is automatically filtered out and never saved to our systems.',
    
    'howStoreTitle': 'How We Store Your Data',
    'howStoreText': 'We take data security seriously and implement industry-standard protection measures:',
    'howStoreItem1': 'All refresh tokens and access tokens are encrypted at rest using AES-256 encryption',
    'howStoreItem2': 'Database credentials are stored securely and never exposed',
    'howStoreItem3': 'Access to seller data is restricted to authorized system processes only',
    'howStoreItem4': 'All API communications use HTTPS/TLS encryption',
    'howStoreItem5': 'Access tokens expire automatically within 1 hour and are refreshed as needed',
    
    'dataRetentionTitle': 'Data Retention Policy',
    'dataRetentionText': 'We retain your data according to the following policies:',
    'dataRetentionItem1': 'Seller Credentials: Refresh tokens are stored indefinitely until you revoke access or delete your account',
    'dataRetentionItem2': 'Access Tokens: Temporary tokens expire automatically within 1 hour',
    'dataRetentionItem3': 'Order & Sales Data: Stored as long as your account is active to provide analytics and reporting',
    'dataRetentionItem4': 'OAuth States: Automatically deleted after 1 hour or upon successful authentication',
    
    'complianceTitle': 'Compliance with Amazon Policies',
    'complianceText': 'Our platform fully complies with Amazon\'s Selling Partner API Data Protection Policy. We:',
    'complianceItem1': 'Never store or process customer PII',
    'complianceItem2': 'Implement mandatory PII redaction at the API layer',
    'complianceItem3': 'Use secure token storage with encryption',
    'complianceItem4': 'Provide transparent data handling practices',
    'complianceItem5': 'Respect seller data ownership and control',
    
    'yourRightsTitle': 'Your Data Rights',
    'yourRightsText': 'You have complete control over your data:',
    'yourRightsItem1': 'Access: View all data we\'ve collected from your Amazon account through your dashboard',
    'yourRightsItem2': 'Deletion: Delete your account and all associated data instantly at any time',
    'yourRightsItem3': 'Revocation: Revoke our access to your Amazon account at any time through Amazon Seller Central',
    'yourRightsItem4': 'Export: Request a copy of your data by contacting our support team',
    'yourRightsItem5': 'Correction: Data is synced from Amazon - any corrections should be made in Seller Central',
    
    'dataSharingTitle': 'Data Sharing and Third Parties',
    'dataSharingText': 'We do not sell, rent, or share your data with third parties for marketing purposes. Your data may only be accessed by:',
    'dataSharingItem1': 'Our secure backend systems for providing the service',
    'dataSharingItem2': 'We are using a secure VPS (Virtual Private Server) provider to host our application and database',
    'dataSharingItem3': 'You, through your dashboard and account settings',
    
    'cookiesTitle': 'Cookies and Tracking',
    'cookiesText': 'We use essential cookies to operate the platform. With your consent, we may use Google Tag Manager, Google Ads, and Contentsquare to measure site performance and improve your experience. You can reject optional cookies or change your choice by clearing this site\'s data in your browser settings.',
    
    'securityTitle': 'Security Measures',
    'securityText': 'We implement comprehensive security measures including:',
    'securityItem1': 'End-to-end encryption for sensitive data',
    'securityItem2': 'Regular security audits and updates',
    'securityItem3': 'Secure OAuth 2.0 authentication flow',
    'securityItem4': 'CSRF protection for all state-changing operations',
    'securityItem5': 'Automatic cleanup of expired tokens and states',
    'securityItem6': 'Sanitized logging that never includes sensitive information',
    
    'changesTitle': 'Changes to This Policy',
    'changesText': 'We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. We will notify you of any material changes by updating the "Last Updated" date at the top of this policy.',
    
    'contactTitle': 'Contact Us',
    'contactText': 'If you have any questions about this Privacy Policy or our data practices, please contact us:',
    'responseTime': 'Response Time: Within 24-48 hours',

  }
};

export const PRICING_PLANS = {
  ar: [
    {
      id: 'free',
      title: 'الخطة المجانية',
    },
    {
      id: 'starter',
      title: 'الخطة الأبتدائية',
      target: 'الفئة المستهدفة: البائعين الجدد',
      price: { usd: 10, period: 'شهريًا', originalUsd: 20 },
      discountText: 'خصم 50%',
      cta: 'ابدأ الآن',
      limitsTitle: 'الحدود:',
      features: [
        'ربط API مع أمازون، نون، جوميا وترينديول',
        'لوحة لعرض تحليلات المبيعات والمخزون والمالية',
        'احسبلي - مساعدك لتسعير المنتجات: (غير محدود)',
        'ايما - لأسئلة التجارة الإلكترونية: (75 سؤال/شهر)',
        'بكام - لتحليل أسعار السوق: (35 نتيجة/شهر)',
        'ألفا - مساعدك الذكي لانشاء الصور: (25 صورة/شهر)',
        'ليو -  مساعدك لانشاء المحتوى: (25 عملية/شهر)',
        'احجز خبير لتقييم حساباتك: ( 1 اجتماغ مجاني )',
        'مدقق لتقارير الضرائب: ( 1 اجتماغ مجاني )',
        'تدريب متخصص في المنصات: ( 1 اجتماغ مجاني )',
        'الوصول إلى فرص البيع',
        'الوصول إلى سوق الموردين',
      ],
    },
    {
      id: 'basic',
      title: 'الخطة الأساسية',
      target: 'الفئة المستهدفة: البائعين الجدد والصغار',
      price: { usd: 20, period: 'شهريًا', originalUsd: 40 },
      discountText: 'خصم 50%',
      cta: 'ابدأ الآن',
      limitsTitle: 'الحدود:',
      features: [
        'ربط API مع أمازون، نون، جوميا وترينديول',
        'لوحة لعرض تحليلات المبيعات والمخزون والمالية',
        'احسبلي - مساعدك لتسعير المنتجات: (غير محدود)',
        'ايما - لأسئلة التجارة الإلكترونية: (150 سؤال/شهر)',
        'بكام - لتحليل أسعار السوق: (75 نتيجة/شهر)',
        'ألفا - مساعدك الذكي لانشاء الصور: (50 صورة/شهر)',
        'ليو -  مساعدك لانشاء المحتوى: (50 عملية/شهر)',
        'احجز خبير لتقييم حساباتك: ( 1 اجتماغ مجاني )',
        'مدقق لتقارير الضرائب: ( 1 اجتماغ مجاني )',
        'تدريب متخصص في المنصات: ( 1 اجتماغ مجاني )',
        'الوصول إلى فرص البيع',
        'الوصول إلى سوق الموردين',
      ],
    },
    {
      id: 'pro',
      title: 'الخطة الاحترافية',
      target: 'الفئة المستهدفة: البائعين النشطين والشركات المتوسطة',
      price: { usd: 35, period: 'شهريًا', originalUsd: 70 },
      discountText: 'خصم 50%',
      cta: 'ابدأ الآن',
      limitsTitle: 'الحدود:',
      features: [
        'ربط API مع أمازون، نون، جوميا وترينديول',
        'لوحة لعرض تحليلات المبيعات والمخزون والمالية',
        'احسبلي - مساعدك لتسعير المنتجات: (غير محدود)',
        'ايما - لأسئلة التجارة الإلكترونية: (250 سؤال/شهر)',
        'بكام - لتحليل أسعار السوق: (100 نتيجة/شهر)',
        'ألفا - مساعدك الذكي لانشاء الصور: (100 صورة/شهر)',
        'ليو -  مساعدك لانشاء المحتوى: (100 عملية/شهر)',
        'احجز خبير لتقييم حساباتك: ( 1 اجتماغ مجاني )',
        'مدقق لتقارير الضرائب: ( 1 اجتماغ مجاني )',
        'تدريب متخصص في المنصات: ( 1 اجتماغ مجاني )',
        'الوصول إلى فرص البيع',
        'الوصول إلى سوق الموردين',
      ],
    },
    {
      id: 'enterprise',
      title: 'خطة المؤسسات',
      target: 'الفئة المستهدفة: العلامات التجارية والشركات الكبرى',
      price: { usd: 50, period: 'شهريًا', originalUsd: 100 },
      discountText: 'خصم 50%',
      cta: 'ابدأ الآن',
      limitsTitle: 'الحدود:',
      features: [
        'ربط API مع أمازون، نون، جوميا وترينديول',
        'لوحة لعرض تحليلات المبيعات والمخزون والمالية',
        'احسبلي - مساعدك لتسعير المنتجات: (غير محدود)',
        'ايما - لأسئلة التجارة الإلكترونية: (350 سؤال/شهر)',
        'بكام - لتحليل أسعار السوق: (150 نتيجة/شهر)',
        'ألفا - مساعدك الذكي لانشاء الصور: (200 صورة/شهر)',
        'ليو -  مساعدك لانشاء المحتوى: (200 عملية/شهر)',
        'احجز خبير لتقييم حساباتك: ( 2 اجتماغ مجاني )',
        'مدقق لتقارير الضرائب: ( 2 اجتماغ مجاني )',
        'تدريب متخصص في المنصات: ( 2 اجتماغ مجاني )',
        'الوصول إلى فرص البيع',
        'الوصول إلى سوق الموردين',
      ],
    },
  ],
  en: [
    {
      id: 'free',
      title: 'Free plan',
    },
    {
      id: 'starter',
      title: 'Starter plan',
      target: 'Target: New sellers',
      price: { usd: 10, period: '/ month', originalUsd: 20 },
      discountText: 'Discounted 50%',
      cta: 'START NOW',
      limitsTitle: 'Limits:',
      features: [
        'API integration with Multiple Marketplaces',
        'Connecto Dashboard insights on sales, inventory',
        'Fees calculator: Unlimited',
        'Emma (support agent): (75 questions/month)',
        'Pricing history Agent: (35 Results/month)',
        'Alpha the Image Generator: (25 images/month)',
        'Leo the Content Generator: (25 Results/month)',
        '( 1 free meeting ) with Expert Account Manager',
        '( 1 free meeting ) with Tax Auditor',
        'Training for E-commerce Platforms: ( 1 session )',
        'Access to Selling Opportunities',
        'Access to Vendors data',
      ],
    },
    {
      id: 'basic',
      title: 'Basic plan',
      target: 'Target: New & Small sellers',
      price: { usd: 20, period: '/ month', originalUsd: 40 },
      discountText: 'Discounted 50%',
      cta: 'START NOW',
      limitsTitle: 'Limits:',
      features: [
        'API integration with Multiple Marketplaces',
        'Connecto Dashboard insights on sales, inventory',
        'Fees calculator: Unlimited',
        'Emma (support agent): (150 questions/month)',
        'Pricing history Agent: (75 Results/month)',
        'Alpha the Image Generator: (50 images/month)',
        'Leo the Content Generator: (50 Results/month)',
        '( 1 free meeting ) with Expert Account Manager',
        '( 1 free meeting ) with Tax Auditor',
        'Training for E-commerce Platforms: ( 1 session )',
        'Access to Selling Opportunities',
        'Access to Vendors data',
      ],
    },
    {
      id: 'pro',
      title: 'Pro plan',
      target: 'Target: Active Sellers , Mid Sized Companies',
      price: { usd: 35, period: '/ month', originalUsd: 70 },
      discountText: 'Discounted 50%',
      cta: 'START NOW',
      limitsTitle: 'Limits:',
      features: [
        'API integration with Multiple Marketplaces',
        'Connecto Dashboard insights on sales, inventory',
        'Fees calculator: Unlimited',
        'Emma (support agent): (250 questions/month)',
        'Pricing history Agent: (100 Results/month)',
        'Alpha the Image Generator: (100 images/month)',
        'Leo the Content Generator: (100 Results/month)',
        '( 1 free meeting ) with Expert Account Manager',
        '( 1 free meeting ) with Tax Auditor',
        'Training for E-commerce Platforms: ( 1 session )',
        'Access to Selling Opportunities',
        'Access to Vendors data',
      ],
    },
    {
      id: 'enterprise',
      title: 'Enterprise plan',
      target: 'Target: Brands – Corporation',
      price: { usd: 50, period: '/ month', originalUsd: 100 },
      discountText: 'Discounted 50%',
      cta: 'START NOW',
      limitsTitle: 'Limits:',
      features: [
        'API integration with Multiple Marketplaces',
        'Connecto Dashboard insights on sales, inventory',
        'Fees calculator: Unlimited',
        'Emma (support agent): (350 questions/month)',
        'Pricing history Agent: (150 Results/month)',
        'Alpha the Image Generator: (200 images/month)',
        'Leo the Content Generator: (200 Results/month)',
        '( 2 free meeting ) with Expert Account Manager',
        '( 2 free meeting ) with Tax Auditor',
        'Training for E-commerce Platforms: ( 2 session )',
        'Access to Selling Opportunities',
        'Access to Vendors data',
      ],
    },
  ],
  'scaleTitle': 'Everything You Need To Scale Marketplaces',
  'scaleCard1Title': 'Connecto Platform AI-Powered',
  'scaleCard1Desc': 'Built to support your team\'s workflow from product creation to marketplace publishing.',
  'scaleCard2Title': 'Account Management',
  'scaleCard2Desc': 'Daily operations handled by experts.',
  'scaleCard1Feat1': 'AI Product Listing Generation',
  'scaleCard1Feat2': 'High-Converting Content Creation',
  'scaleCard1Feat3': 'Pre-Publish Profit & Fee Calculation',
  'scaleCard1Feat4': 'Unified Performance Dashboard',
  'scaleCard2Feat1': 'Seller Account Registration & Setup',
  'scaleCard2Feat2': 'Listing Creation & A+ Content Development',
  'scaleCard2Feat3': 'Ad Campaign Management & Sales Scaling',
  'scaleCard2Feat4': 'Order, Return & Financial Operation Tracking',
};
